// Auto-generated by /app/scripts/build_i18n.py
export const QUESTIONS = [
 {
  "id": 1,
  "category": "cpp-core",
  "q": "What is the size of an empty class `class E {};` in C++ (e.g., sizeof(E))?",
  "options": [
   "0 bytes",
   "1 byte",
   "4 bytes",
   "Implementation-defined, usually 8 bytes"
  ],
  "correctIndex": 1,
  "explanation": "Distinct objects must have distinct addresses, so an empty class has size at least 1; typically it is exactly 1."
 },
 {
  "id": 2,
  "category": "cpp-core",
  "q": "What is the output?\nint x = 5;\nint &r = x;\nr++;\nstd::cout << x;",
  "options": [
   "5",
   "6",
   "Compilation error",
   "Undefined behaviour"
  ],
  "correctIndex": 1,
  "explanation": "r is an alias of x, so r++ increments x to 6."
 },
 {
  "id": 3,
  "category": "cpp-core",
  "q": "Why should a base class with virtual functions have a virtual destructor?",
  "options": [
   "To make the destructor run faster",
   "To allow the class to be copied",
   "To avoid UB when deleting a derived object via a base pointer",
   "To prevent the class from being instantiated"
  ],
  "correctIndex": 2,
  "explanation": "Deleting a derived object through a base pointer without a virtual destructor is undefined behaviour and may skip the derived destructor."
 },
 {
  "id": 4,
  "category": "cpp-core",
  "q": "What is the output?\nint a = 10;\nauto f = [a]() mutable { a++; return a; };\nstd::cout << f() << a;",
  "options": [
   "1111",
   "1110",
   "1010",
   "1011"
  ],
  "correctIndex": 1,
  "explanation": "The lambda modifies its own captured copy (11), while the outer a remains 10, so it prints 11 then 10."
 },
 {
  "id": 5,
  "category": "cpp-core",
  "q": "Which operation on a std::vector can invalidate all existing iterators to it?",
  "options": [
   "Calling size()",
   "Calling push_back() that triggers reallocation",
   "Calling operator[]",
   "Calling front()"
  ],
  "correctIndex": 1,
  "explanation": "When capacity is exceeded, the vector reallocates its storage and all iterators, pointers and references become invalid."
 },
 {
  "id": 6,
  "category": "cpp-core",
  "q": "Which statement about std::unique_ptr<T> is correct?",
  "options": [
   "It can be copied freely",
   "It uses reference counting",
   "It is non-copyable but movable",
   "It cannot hold a custom deleter"
  ],
  "correctIndex": 2,
  "explanation": "unique_ptr models exclusive ownership: its copy operations are deleted, but ownership can be transferred via std::move."
 },
 {
  "id": 7,
  "category": "cpp-core",
  "q": "Which declaration lets you modify the pointed-to int but NOT reseat the pointer?",
  "options": [
   "const int* p",
   "int* const p",
   "const int* const p",
   "int const* p"
  ],
  "correctIndex": 1,
  "explanation": "int* const p is a constant pointer to a mutable int; the others make the pointee read-only."
 },
 {
  "id": 8,
  "category": "cpp-core",
  "q": "On a typical platform with 4-byte int and default alignment, what is sizeof(S)?\nstruct S { char c; int i; char d; };",
  "options": [
   "6",
   "8",
   "12",
   "16"
  ],
  "correctIndex": 2,
  "explanation": "c is followed by 3 padding bytes, i takes 4, d takes 1 plus 3 bytes of tail padding, giving 12."
 },
 {
  "id": 9,
  "category": "cpp-core",
  "q": "In C++17, how can you define a static data member inside the class body without a separate out-of-class definition?",
  "options": [
   "Declare it as `static inline`",
   "Declare it as `static extern`",
   "Declare it as `static volatile`",
   "It is not possible in C++17"
  ],
  "correctIndex": 0,
  "explanation": "C++17 introduced inline variables, so `static inline int count = 0;` is defined in-class."
 },
 {
  "id": 10,
  "category": "cpp-core",
  "q": "What is the output?\nstd::map<std::string,int> m;\nstd::cout << m[\"a\"] << m.size();",
  "options": [
   "00",
   "01",
   "Throws std::out_of_range",
   "Undefined behaviour"
  ],
  "correctIndex": 1,
  "explanation": "operator[] inserts a value-initialised int (0) for the missing key, so the value is 0 and the size becomes 1."
 },
 {
  "id": 11,
  "category": "cpp-core",
  "q": "Which is the canonical move constructor signature for class T?",
  "options": [
   "T(const T&)",
   "T(T&)",
   "T(T&&) noexcept",
   "T(const T&&) const"
  ],
  "correctIndex": 2,
  "explanation": "A move constructor takes an rvalue reference T&& and is ideally marked noexcept so containers can use it."
 },
 {
  "id": 12,
  "category": "cpp-core",
  "q": "What is the output?\nstruct A { virtual void f(){ std::cout<<\"A\"; } };\nstruct B : A { void f() override { std::cout<<\"B\"; } };\nB b; A a = b; a.f();",
  "options": [
   "A",
   "B",
   "AB",
   "Compilation error"
  ],
  "correctIndex": 0,
  "explanation": "Assigning b to an A object slices it; a is a pure A, so A::f is called."
 },
 {
  "id": 13,
  "category": "cpp-core",
  "q": "What is the problem with this code?\nstd::string_view sv = std::string(\"hello\");\nstd::cout << sv;",
  "options": [
   "No problem, it prints hello",
   "sv dangles because the temporary string is destroyed",
   "string_view cannot be printed",
   "It will not compile in C++17"
  ],
  "correctIndex": 1,
  "explanation": "string_view does not own data; the temporary std::string dies at the end of the statement, leaving sv dangling (UB)."
 },
 {
  "id": 14,
  "category": "cpp-core",
  "q": "Which C++17 feature does this code use?\nif (auto it = m.find(k); it != m.end()) { /*...*/ }",
  "options": [
   "Structured bindings",
   "if statement with initializer",
   "Fold expressions",
   "Concepts"
  ],
  "correctIndex": 1,
  "explanation": "C++17 allows an init-statement inside if, limiting the variable's scope to the if/else."
 },
 {
  "id": 15,
  "category": "cpp-core",
  "q": "What is the output?\nvoid f(int){ std::cout<<\"int\"; }\nvoid f(double){ std::cout<<\"double\"; }\nf(3.0f);",
  "options": [
   "int",
   "double",
   "Ambiguous call error",
   "Prints nothing"
  ],
  "correctIndex": 1,
  "explanation": "float to double is a floating-point promotion, which beats the float to int conversion, so f(double) is chosen."
 },
 {
  "id": 16,
  "category": "cpp-core",
  "q": "What is printed?\nconst std::string s = \"a\";\nstd::string t = std::move(s);\nstd::cout << s.size();",
  "options": [
   "0",
   "1",
   "Undefined behaviour",
   "Compilation error"
  ],
  "correctIndex": 1,
  "explanation": "std::move on a const object yields const string&&, which binds to the copy constructor, so s is unchanged and its size is 1."
 },
 {
  "id": 17,
  "category": "cpp-core",
  "q": "What is the average and worst-case time complexity of lookup in std::unordered_map?",
  "options": [
   "O(1) average, O(n) worst",
   "O(log n) average, O(n) worst",
   "O(1) average, O(log n) worst",
   "O(n) average, O(n) worst"
  ],
  "correctIndex": 0,
  "explanation": "Hash lookup is constant on average, but many collisions can degrade it to linear in the worst case."
 },
 {
  "id": 18,
  "category": "cpp-core",
  "q": "Which cast performs a runtime type check on polymorphic types and returns nullptr on failure for pointers?",
  "options": [
   "static_cast",
   "reinterpret_cast",
   "const_cast",
   "dynamic_cast"
  ],
  "correctIndex": 3,
  "explanation": "dynamic_cast uses RTTI to verify the cast and yields nullptr (pointers) or throws bad_cast (references) if it fails."
 },
 {
  "id": 19,
  "category": "cpp-core",
  "q": "What is the output?\nint arr[] = {1,2,3,4};\nstd::cout << sizeof(arr)/sizeof(arr[0]);",
  "options": [
   "1",
   "4",
   "16",
   "Depends on the compiler"
  ],
  "correctIndex": 1,
  "explanation": "sizeof(arr) is the total array size and dividing by the element size gives the element count, 4."
 },
 {
  "id": 20,
  "category": "cpp-core",
  "q": "In C++11 and later, what happens if a destructor (implicitly noexcept) throws an exception that escapes it?",
  "options": [
   "The exception propagates normally to the caller",
   "The exception is silently ignored",
   "std::terminate is called",
   "The object is destroyed twice"
  ],
  "correctIndex": 2,
  "explanation": "Destructors are implicitly noexcept, so an escaping exception triggers std::terminate unless declared noexcept(false)."
 },
 {
  "id": 21,
  "category": "cpp-core",
  "q": "What is the output?\nint x = 10;\nint* p = &x;\nint** pp = &p;\n**pp = 20;\nstd::cout << x;",
  "options": [
   "10",
   "20",
   "An address is printed",
   "Compile error"
  ],
  "correctIndex": 1,
  "explanation": "**pp dereferences twice to reach x, so the assignment changes x to 20."
 },
 {
  "id": 22,
  "category": "cpp-core",
  "q": "What is the output?\nstd::vector<int> v(3, 7);\nstd::vector<int> w{3, 7};\nstd::cout << v.size() << w.size();",
  "options": [
   "33",
   "23",
   "32",
   "22"
  ],
  "correctIndex": 2,
  "explanation": "v(3,7) makes 3 elements; w{3,7} uses the initializer_list constructor and holds 2 elements."
 },
 {
  "id": 23,
  "category": "cpp-core",
  "q": "What is the output?\nvoid f(){ static int c = 0; c++; std::cout << c; }\nint main(){ f(); f(); f(); }",
  "options": [
   "111",
   "012",
   "321",
   "123"
  ],
  "correctIndex": 3,
  "explanation": "A static local is initialized once and keeps its value across calls, so it prints 1, 2, 3."
 },
 {
  "id": 24,
  "category": "cpp-core",
  "q": "What is the effect of declaring `T(const T&) = delete;` in class T?",
  "options": [
   "Any attempt to copy a T fails to compile",
   "Copying silently becomes a shallow copy",
   "Copying compiles but throws at runtime",
   "The compiler always substitutes the move constructor"
  ],
  "correctIndex": 0,
  "explanation": "A deleted function takes part in overload resolution, but selecting it is a compile-time error."
 },
 {
  "id": 25,
  "category": "cpp-core",
  "q": "What is the result of this code?\nint i = 5;\nstd::cout << i++ + ++i;",
  "options": [
   "10",
   "11",
   "12",
   "Undefined behavior"
  ],
  "correctIndex": 3,
  "explanation": "i is modified twice without sequencing between the operands of +, which is undefined behavior."
 },
 {
  "id": 26,
  "category": "cpp-core",
  "q": "What is the output?\nauto a = std::make_shared<int>(1);\nauto b = a;\nauto c = std::move(a);\nstd::cout << a.use_count() << b.use_count();",
  "options": [
   "02",
   "12",
   "22",
   "01"
  ],
  "correctIndex": 0,
  "explanation": "Moving from a leaves it empty (count 0). b and c share ownership, so the count is 2."
 },
 {
  "id": 27,
  "category": "cpp-core",
  "q": "Which C++17 feature allows `std::pair p{1, 2.5};` without writing the template arguments?",
  "options": [
   "Structured bindings",
   "Inline variables",
   "Class template argument deduction (CTAD)",
   "Fold expressions"
  ],
  "correctIndex": 2,
  "explanation": "CTAD lets the compiler deduce std::pair<int,double> from the constructor arguments."
 },
 {
  "id": 28,
  "category": "cpp-core",
  "q": "What is the output?\nstruct A{ A(){std::cout<<\"A\";} ~A(){std::cout<<\"a\";} };\nstruct B:A{ B(){std::cout<<\"B\";} ~B(){std::cout<<\"b\";} };\nint main(){ B obj; }",
  "options": [
   "ABab",
   "ABba",
   "BAab",
   "BAba"
  ],
  "correctIndex": 1,
  "explanation": "Construction runs base then derived (AB). Destruction runs in reverse: derived then base (ba)."
 },
 {
  "id": 29,
  "category": "cpp-core",
  "q": "What is the output?\nstd::optional<int> o;\nstd::cout << o.value_or(7);",
  "options": [
   "7",
   "0",
   "Throws std::bad_optional_access",
   "Compile error"
  ],
  "correctIndex": 0,
  "explanation": "value_or returns the supplied default when the optional is empty, without throwing."
 },
 {
  "id": 30,
  "category": "cpp-core",
  "q": "What is wrong with this function?\nconst int& f(){ int x = 5; return x; }",
  "options": [
   "Nothing, it is valid",
   "It will not compile because x is not const",
   "It returns a dangling reference to a local, which is UB to use",
   "It copies x on every call"
  ],
  "correctIndex": 2,
  "explanation": "x is destroyed when f returns, so using the returned reference is undefined behavior."
 },
 {
  "id": 31,
  "category": "cpp-core",
  "q": "What is printed?\nstruct A{ A(){ f(); } virtual void f(){ std::cout<<\"A\"; } };\nstruct B:A{ void f() override { std::cout<<\"B\"; } };\nint main(){ B b; }",
  "options": [
   "B",
   "A",
   "AB",
   "Undefined behavior"
  ],
  "correctIndex": 1,
  "explanation": "During A's constructor the object's dynamic type is A, so A::f is called, not B::f."
 },
 {
  "id": 32,
  "category": "cpp-core",
  "q": "What happens with this code?\ntemplate<typename T> T add(T a, T b){ return a + b; }\nauto r = add(1, 2.5);",
  "options": [
   "Returns 3 as int",
   "Returns 3.5 as double",
   "Returns 3.5 as float",
   "Compile error: conflicting deduction for T"
  ],
  "correctIndex": 3,
  "explanation": "T is deduced as int from the first argument and as double from the second, so deduction fails."
 },
 {
  "id": 33,
  "category": "cpp-core",
  "q": "Which statement about a `constexpr` function is correct?",
  "options": [
   "It must always run at compile time",
   "It can only be called with literals",
   "It can be evaluated at compile time if its arguments are constant expressions",
   "It cannot be called at runtime"
  ],
  "correctIndex": 2,
  "explanation": "constexpr functions are usable in constant expressions but may also be called at runtime with non-constant arguments."
 },
 {
  "id": 34,
  "category": "cpp-core",
  "q": "What is the output?\nint a[3] = {1, 2, 3};\nint* p = a;\nstd::cout << *(p + 2) << p[1];",
  "options": [
   "32",
   "23",
   "12",
   "31"
  ],
  "correctIndex": 0,
  "explanation": "*(p+2) is a[2], which is 3, and p[1] is a[1], which is 2, so the output is 32."
 },
 {
  "id": 35,
  "category": "cpp-core",
  "q": "What is the output?\nstd::set<int> s{3, 1, 3, 2};\nstd::cout << s.size() << *s.begin();",
  "options": [
   "41",
   "31",
   "33",
   "32"
  ],
  "correctIndex": 1,
  "explanation": "A set drops duplicates, leaving {1,2,3}: size 3 and smallest element 1, so the output is 31."
 },
 {
  "id": 36,
  "category": "oop",
  "q": "In C++, what is the default access specifier for members of a class declared with the keyword `class`?",
  "options": [
   "public",
   "private",
   "protected",
   "It depends on the compiler"
  ],
  "correctIndex": 1,
  "explanation": "Members of a `class` are private by default, while members of a `struct` are public by default."
 },
 {
  "id": 37,
  "category": "oop",
  "q": "`Base* p = new Derived; delete p;` where Base has a non-virtual destructor. What is the result?",
  "options": [
   "Both destructors run in correct order",
   "Only the Derived destructor runs",
   "Undefined behavior",
   "Compile-time error"
  ],
  "correctIndex": 2,
  "explanation": "Deleting a derived object through a base pointer without a virtual destructor is undefined behavior."
 },
 {
  "id": 38,
  "category": "oop",
  "q": "Output?\nstruct A{ virtual void f(){cout<<\"A\";} };\nstruct B:A{ void f() override {cout<<\"B\";} };\nint main(){ A* p = new B; p->f(); }",
  "options": [
   "A",
   "B",
   "AB",
   "Compile error"
  ],
  "correctIndex": 1,
  "explanation": "f is virtual, so the call is dispatched on the dynamic type B at runtime."
 },
 {
  "id": 39,
  "category": "oop",
  "q": "Output?\nstruct A{ virtual void f(){cout<<\"A\";} };\nstruct B:A{ void f() override {cout<<\"B\";} };\nvoid g(A a){ a.f(); }\nint main(){ B b; g(b); }",
  "options": [
   "B",
   "A",
   "AB",
   "Undefined behavior"
  ],
  "correctIndex": 1,
  "explanation": "Passing by value slices b into an A object, so A::f is called."
 },
 {
  "id": 40,
  "category": "oop",
  "q": "Output?\nstruct B{ B(){cout<<\"B\";} ~B(){cout<<\"b\";} };\nstruct D:B{ D(){cout<<\"D\";} ~D(){cout<<\"d\";} };\nint main(){ D x; }",
  "options": [
   "BDbd",
   "DBdb",
   "BDdb",
   "DBbd"
  ],
  "correctIndex": 2,
  "explanation": "Constructors run base then derived; destructors run in reverse: derived then base, giving BDdb."
 },
 {
  "id": 41,
  "category": "oop",
  "q": "Output?\nstruct A{ A(){ f(); } virtual void f(){cout<<\"A\";} };\nstruct B:A{ void f() override {cout<<\"B\";} };\nint main(){ B b; }",
  "options": [
   "A",
   "B",
   "AB",
   "Undefined behavior"
  ],
  "correctIndex": 0,
  "explanation": "During A's constructor the object is only an A, so virtual dispatch resolves to A::f."
 },
 {
  "id": 42,
  "category": "oop",
  "q": "Which statement about pure virtual functions in C++ is true?",
  "options": [
   "A class with one cannot have a constructor",
   "A pure virtual function cannot have a body",
   "A pure virtual function may have a definition outside the class",
   "The class can still be instantiated directly"
  ],
  "correctIndex": 2,
  "explanation": "`virtual void f()=0;` may still be defined, e.g. for a pure virtual destructor, but the class stays abstract."
 },
 {
  "id": 43,
  "category": "oop",
  "q": "In the diamond problem (D derives from B and C, both derive from A), which feature ensures only one A subobject in D?",
  "options": [
   "Virtual inheritance",
   "Private inheritance",
   "Function overloading",
   "Using final on A"
  ],
  "correctIndex": 0,
  "explanation": "Declaring `B : virtual A` and `C : virtual A` makes D share a single A subobject."
 },
 {
  "id": 44,
  "category": "oop",
  "q": "Output?\nstruct A{ void f(int){cout<<\"int\";} };\nstruct B:A{ void f(double){cout<<\"dbl\";} };\nint main(){ B b; b.f(1); }",
  "options": [
   "int",
   "dbl",
   "Ambiguity compile error",
   "intdbl"
  ],
  "correctIndex": 1,
  "explanation": "B::f hides A::f by name, so only f(double) is considered and 1 converts to double."
 },
 {
  "id": 45,
  "category": "oop",
  "q": "What is the main benefit of marking a derived function with `override`?",
  "options": [
   "It makes the function run faster",
   "It makes the function virtual in unrelated classes",
   "It lets the function access private base members",
   "The compiler errors if no matching base virtual exists"
  ],
  "correctIndex": 3,
  "explanation": "`override` catches signature mismatches, such as a missing const, at compile time."
 },
 {
  "id": 46,
  "category": "oop",
  "q": "What does declaring `class Foo final : public Bar {}` achieve?",
  "options": [
   "Foo cannot be derived from",
   "Foo cannot be instantiated",
   "Bar cannot be derived from",
   "All Foo methods become virtual"
  ],
  "correctIndex": 0,
  "explanation": "`final` on a class prevents any further inheritance from it."
 },
 {
  "id": 47,
  "category": "oop",
  "q": "Output?\nstruct A{ virtual void f(int x=1){cout<<\"A\"<<x;} };\nstruct B:A{ void f(int x=2) override {cout<<\"B\"<<x;} };\nint main(){ A* p = new B; p->f(); }",
  "options": [
   "A1",
   "A2",
   "B2",
   "B1"
  ],
  "correctIndex": 3,
  "explanation": "The function is chosen dynamically (B::f), but default arguments are bound statically from A's declaration (1)."
 },
 {
  "id": 48,
  "category": "oop",
  "q": "Will this compile?\nclass B{ public: int v; };\nclass D : private B {};\nint main(){ D d; d.v = 1; }",
  "options": [
   "Yes, v stays public",
   "Yes, v becomes protected",
   "No, v is inaccessible through D",
   "No, private inheritance is illegal"
  ],
  "correctIndex": 2,
  "explanation": "Private inheritance makes B's public members private in D, so main cannot access v."
 },
 {
  "id": 49,
  "category": "oop",
  "q": "Which set is part of the C++11 'Rule of Five'?",
  "options": [
   "Constructor, destructor, getter, setter, operator<<",
   "Destructor, copy/move constructors, copy/move assignment",
   "Default ctor, copy ctor, virtual dtor, swap, hash",
   "new, delete, malloc, free, realloc"
  ],
  "correctIndex": 1,
  "explanation": "If a class manages resources, define or delete the destructor, copy and move constructors, and copy and move assignment operators."
 },
 {
  "id": 50,
  "category": "oop",
  "q": "Which of these member functions cannot be declared virtual in C++?",
  "options": [
   "Destructor",
   "Const member function",
   "Static member function",
   "Private member function"
  ],
  "correctIndex": 2,
  "explanation": "Static functions have no `this` pointer, so they cannot be virtual; the others can be."
 },
 {
  "id": 51,
  "category": "oop",
  "q": "What does `dynamic_cast<Derived*>(basePtr)` return if the object is not actually a Derived?",
  "options": [
   "A dangling pointer",
   "nullptr",
   "It throws std::bad_cast",
   "It slices the object"
  ],
  "correctIndex": 1,
  "explanation": "The pointer form returns nullptr on failure; only the reference form throws bad_cast."
 },
 {
  "id": 52,
  "category": "oop",
  "q": "Class A declares `friend class F;`. Class B derives from A. Can F access B's private members?",
  "options": [
   "Yes, friendship is inherited",
   "Yes, but only B's protected members",
   "Only if B is declared virtual",
   "No, friendship is not inherited"
  ],
  "correctIndex": 3,
  "explanation": "Friendship is neither inherited nor transitive; F gets access only to A's own private members."
 },
 {
  "id": 53,
  "category": "oop",
  "q": "Output?\nstruct A{ A(int x){cout<<x;} };\nstruct B:virtual A{ B():A(1){} };\nstruct C:virtual A{ C():A(2){} };\nstruct D:B,C{ D():A(3){} };\nint main(){ D d; }",
  "options": [
   "3",
   "12",
   "123",
   "1"
  ],
  "correctIndex": 0,
  "explanation": "The most derived class (D) initializes the virtual base A, and the initializers in B and C are ignored."
 },
 {
  "id": 54,
  "category": "oop",
  "q": "On a typical 64-bit compiler, what is sizeof(S)?\nstruct S{ virtual void f(){} int x; };",
  "options": [
   "4",
   "8",
   "12",
   "16"
  ],
  "correctIndex": 3,
  "explanation": "S holds an 8-byte vptr plus a 4-byte int, padded to 16 for alignment."
 },
 {
  "id": 55,
  "category": "oop",
  "q": "Base declares `virtual Base* clone();`. Which override in Derived (publicly derived from Base) is valid?",
  "options": [
   "Derived* clone() override;",
   "Derived clone() override;",
   "int clone() override;",
   "void clone() override;"
  ],
  "correctIndex": 0,
  "explanation": "Covariant return types allow an override to return a pointer or reference to a more derived class."
 },
 {
  "id": 56,
  "category": "oop",
  "q": "Output?\nstruct X{ X(int){cout<<\"x\";} };\nstruct Y{ Y(){cout<<\"y\";} };\nclass T{ X x; Y y; public: T():y(),x(1){} };\nint main(){ T t; }",
  "options": [
   "yx",
   "xy",
   "x",
   "Compile error"
  ],
  "correctIndex": 1,
  "explanation": "Members are initialized in declaration order (x then y), not in the order of the mem-initializer list."
 },
 {
  "id": 57,
  "category": "oop",
  "q": "Output?\nstruct C{ static int n; C(){n++;} ~C(){n--;} };\nint C::n=0;\nint main(){ C a; { C b, c; } C d; cout<<C::n; }",
  "options": [
   "1",
   "3",
   "2",
   "0"
  ],
  "correctIndex": 2,
  "explanation": "n is shared; b and c are destroyed at the inner scope's end, leaving a and d alive, so n is 2."
 },
 {
  "id": 58,
  "category": "oop",
  "q": "Will this compile?\nstruct B{ protected: int x; };\nstruct D:B{ void f(B& b){ b.x = 1; } };",
  "options": [
   "Yes, D can access any protected member of B",
   "No, protected access through a B object is not allowed inside D",
   "No, x is private in B",
   "Yes, but it is undefined behaviour"
  ],
  "correctIndex": 1,
  "explanation": "A derived class may access protected members only via objects of its own type (or further derived), not via a plain B reference."
 },
 {
  "id": 59,
  "category": "oop",
  "q": "What happens?\nstruct A{ virtual ~A() = 0; };\nstruct B:A{};\nint main(){ B b; }",
  "options": [
   "Compiles and runs fine",
   "Compile error: B is abstract",
   "Link error: A::~A() is not defined",
   "Runtime crash only when b is destroyed"
  ],
  "correctIndex": 2,
  "explanation": "A pure virtual destructor is still called during destruction, so it needs a definition; otherwise the linker reports an undefined reference."
 },
 {
  "id": 60,
  "category": "oop",
  "q": "Output in C++17?\nstruct T{ T(){cout<<\"c\";} T(const T&){cout<<\"k\";} };\nT make(){ return T(); }\nint main(){ T a = make(); }",
  "options": [
   "ck",
   "c",
   "ckk",
   "k"
  ],
  "correctIndex": 1,
  "explanation": "C++17 guarantees copy elision for prvalues, so the object is constructed directly in a and only the default constructor runs."
 },
 {
  "id": 61,
  "category": "oop",
  "q": "Output?\nstruct A{ virtual void f(){cout<<\"A\";} };\nstruct B:A{ private: void f() override {cout<<\"B\";} };\nint main(){ B b; A& r = b; r.f(); }",
  "options": [
   "A",
   "B",
   "Compile error: f is private",
   "Undefined behaviour"
  ],
  "correctIndex": 1,
  "explanation": "Access is checked against the static type A (public), while dispatch uses the dynamic type, so B::f runs."
 },
 {
  "id": 62,
  "category": "oop",
  "q": "Will this compile?\nstruct S{ explicit S(int){} };\nvoid g(S){}\nint main(){ g(5); }",
  "options": [
   "Yes, 5 is implicitly converted to S",
   "Yes, but with a warning",
   "No, explicit blocks implicit int-to-S conversion",
   "No, S has no default constructor"
  ],
  "correctIndex": 2,
  "explanation": "An explicit constructor cannot be used for copy-initialization of the parameter from 5; you must write g(S(5))."
 },
 {
  "id": 63,
  "category": "oop",
  "q": "A class owns `int* p = new int;` and defines a destructor that deletes p, but no copy constructor. What goes wrong when an object is copied?",
  "options": [
   "Copy fails to compile",
   "Both copies share p, causing a double delete",
   "The pointer is set to nullptr in the copy",
   "The compiler deep-copies the int automatically"
  ],
  "correctIndex": 1,
  "explanation": "The implicit copy constructor copies the pointer value (shallow copy), so both destructors delete the same memory."
 },
 {
  "id": 64,
  "category": "oop",
  "q": "Will this compile?\nstruct W{ std::unique_ptr<int> p; };\nint main(){ W a; W b = a; }",
  "options": [
   "Yes, p is deep-copied",
   "Yes, ownership is moved automatically",
   "No, W's implicit copy constructor is deleted",
   "No, W needs a virtual destructor"
  ],
  "correctIndex": 2,
  "explanation": "unique_ptr is move-only, so the implicitly generated copy constructor of W is defined as deleted."
 },
 {
  "id": 65,
  "category": "oop",
  "q": "Output?\nstruct S{ void f(){cout<<\"n\";} void f() const {cout<<\"c\";} };\nint main(){ const S s; S t; s.f(); t.f(); }",
  "options": [
   "nn",
   "cc",
   "nc",
   "cn"
  ],
  "correctIndex": 3,
  "explanation": "A const object calls the const overload (c); a non-const object prefers the non-const overload (n)."
 },
 {
  "id": 66,
  "category": "stl",
  "q": "What is the time complexity of inserting an element into a std::map<int,int> with n elements?",
  "options": [
   "O(1)",
   "O(log n)",
   "O(n)",
   "O(n log n)"
  ],
  "correctIndex": 1,
  "explanation": "std::map is typically a red-black tree, so insertion costs O(log n)."
 },
 {
  "id": 67,
  "category": "stl",
  "q": "What are the average and worst-case lookup complexities of std::unordered_map::find?",
  "options": [
   "O(1) average, O(n) worst",
   "O(log n) average, O(n) worst",
   "O(1) average, O(log n) worst",
   "O(n) average, O(n) worst"
  ],
  "correctIndex": 0,
  "explanation": "Hashing gives O(1) on average, but many collisions can degrade lookup to O(n)."
 },
 {
  "id": 68,
  "category": "stl",
  "q": "What is the output?\nvector<int> a(3,5); vector<int> b{3,5};\ncout << a.size() << b.size();",
  "options": [
   "22",
   "33",
   "23",
   "32"
  ],
  "correctIndex": 3,
  "explanation": "a(3,5) makes three 5s (size 3); b{3,5} uses the initializer list and has two elements (size 2)."
 },
 {
  "id": 69,
  "category": "stl",
  "q": "Which statement about std::vector iterator invalidation is correct?",
  "options": [
   "push_back never invalidates iterators",
   "push_back that causes reallocation invalidates all iterators",
   "push_back invalidates only the end() iterator, never reallocating",
   "Iterators stay valid after reallocation if you copy them"
  ],
  "correctIndex": 1,
  "explanation": "On reallocation, the elements move to new storage, so all iterators, pointers and references into the vector are invalidated."
 },
 {
  "id": 70,
  "category": "stl",
  "q": "What does this print?\nvector<int> v{1,2,3,2,4};\nv.erase(remove(v.begin(),v.end(),2),v.end());\nfor(int x:v) cout<<x<<' ';",
  "options": [
   "1 3 4",
   "1 2 3 4",
   "1 3 2 4",
   "1 3 4 2 4"
  ],
  "correctIndex": 0,
  "explanation": "remove shifts the non-2 elements forward and returns the new logical end; erase then deletes the tail."
 },
 {
  "id": 71,
  "category": "stl",
  "q": "What is the output?\nset<int> s{3,1,3,2,1};\ncout << s.size() << *s.begin();",
  "options": [
   "51",
   "31",
   "32",
   "33"
  ],
  "correctIndex": 1,
  "explanation": "The set stores unique sorted elements {1,2,3}, so size is 3 and the smallest is 1."
 },
 {
  "id": 72,
  "category": "stl",
  "q": "What is the output?\nmap<int,int> m;\ncout << m[5] << m.size();",
  "options": [
   "00",
   "01",
   "Runtime error",
   "11"
  ],
  "correctIndex": 1,
  "explanation": "operator[] inserts key 5 with a value-initialized 0, so it prints 0 and then size 1."
 },
 {
  "id": 73,
  "category": "stl",
  "q": "What is printed?\npriority_queue<int> pq;\npq.push(3); pq.push(1); pq.push(4);\ncout << pq.top();",
  "options": [
   "1",
   "3",
   "4",
   "Compile error"
  ],
  "correctIndex": 2,
  "explanation": "The default priority_queue is a max-heap, so top() is the largest element, 4."
 },
 {
  "id": 74,
  "category": "stl",
  "q": "Which declaration creates a min-heap of ints using std::priority_queue?",
  "options": [
   "priority_queue<int, less<int>> pq;",
   "priority_queue<int, greater<int>> pq;",
   "priority_queue<int, vector<int>, greater<int>> pq;",
   "priority_queue<int, vector<int>, less<int>> pq;"
  ],
  "correctIndex": 2,
  "explanation": "The full form needs the container type as the second argument, and greater<int> as the comparator gives a min-heap."
 },
 {
  "id": 75,
  "category": "stl",
  "q": "For sorted vector<int> v{1,3,3,5}, what does this print?\ncout << (upper_bound(v.begin(),v.end(),3) - v.begin());",
  "options": [
   "1",
   "2",
   "3",
   "4"
  ],
  "correctIndex": 2,
  "explanation": "upper_bound returns the first element greater than 3, which is 5 at index 3."
 },
 {
  "id": 76,
  "category": "stl",
  "q": "Why does std::sort(lst.begin(), lst.end()) fail to compile for std::list<int> lst?",
  "options": [
   "list is immutable",
   "sort needs random-access iterators; use lst.sort()",
   "sort works only on vector",
   "list requires a custom comparator"
  ],
  "correctIndex": 1,
  "explanation": "std::sort requires random-access iterators, and std::list provides only bidirectional ones, so use list::sort."
 },
 {
  "id": 77,
  "category": "stl",
  "q": "Why is sort(v.begin(), v.end(), [](int a,int b){return a<=b;}) dangerous?",
  "options": [
   "It sorts in descending order",
   "It is slower but always correct",
   "It violates strict weak ordering, giving undefined behavior",
   "It only fails for negative numbers"
  ],
  "correctIndex": 2,
  "explanation": "A comparator must return false for equal elements; <= breaks that and can cause crashes or out-of-bounds access."
 },
 {
  "id": 78,
  "category": "stl",
  "q": "Which container offers amortized O(1) push_front and push_back plus random access?",
  "options": [
   "std::vector",
   "std::list",
   "std::deque",
   "std::forward_list"
  ],
  "correctIndex": 2,
  "explanation": "std::deque supports O(1) insertion at both ends and O(1) indexing; vector has no push_front, and list has no random access."
 },
 {
  "id": 79,
  "category": "stl",
  "q": "What is printed?\nvector<double> v{0.5,0.5,0.5};\ncout << accumulate(v.begin(),v.end(),0);",
  "options": [
   "1.5",
   "0",
   "1",
   "Compile error"
  ],
  "correctIndex": 1,
  "explanation": "The init value 0 is an int, so the accumulator type is int and each addition truncates back to 0."
 },
 {
  "id": 80,
  "category": "stl",
  "q": "What can you rely on about the iteration order of std::unordered_map?",
  "options": [
   "Sorted by key",
   "Insertion order",
   "Unspecified; it may change after rehashing",
   "Reverse insertion order"
  ],
  "correctIndex": 2,
  "explanation": "Unordered containers give no ordering guarantee, and a rehash can reorder elements."
 },
 {
  "id": 81,
  "category": "stl",
  "q": "What is the output?\nmultiset<int> s{1,2,2,3};\ns.erase(2);\ncout << s.size();",
  "options": [
   "2",
   "3",
   "4",
   "1"
  ],
  "correctIndex": 0,
  "explanation": "erase(key) removes all elements equal to the key, so both 2s go and {1,3} remains. Erasing by iterator would remove only one."
 },
 {
  "id": 82,
  "category": "stl",
  "q": "What is printed?\nvector<int> v{1,2,3};\nnext_permutation(v.begin(),v.end());\nfor(int x:v) cout<<x;",
  "options": [
   "123",
   "132",
   "213",
   "321"
  ],
  "correctIndex": 1,
  "explanation": "The next lexicographic permutation after 123 is 132."
 },
 {
  "id": 83,
  "category": "stl",
  "q": "What is the output (C++17)?\nmap<string,int> m{{\"a\",1}};\nfor(auto& [k,v]: m) v++;\ncout << m[\"a\"];",
  "options": [
   "1",
   "2",
   "Compile error",
   "0"
  ],
  "correctIndex": 1,
  "explanation": "The structured binding by reference makes v refer to the mapped value, so the increment modifies the map."
 },
 {
  "id": 84,
  "category": "stl",
  "q": "Which statement about std::vector<bool> is true?",
  "options": [
   "It stores each bool in one byte",
   "operator[] returns a proxy object, so auto& b = v[0] fails",
   "It is identical to vector<char>",
   "It supports data() returning bool*"
  ],
  "correctIndex": 1,
  "explanation": "vector<bool> is a bit-packed specialization whose operator[] returns a proxy rvalue, which cannot bind to a non-const lvalue reference."
 },
 {
  "id": 85,
  "category": "stl",
  "q": "What is printed?\nvector<int> v{1,1,2,2,1};\nv.erase(unique(v.begin(),v.end()),v.end());\ncout << v.size();",
  "options": [
   "2",
   "3",
   "5",
   "1"
  ],
  "correctIndex": 1,
  "explanation": "unique removes only consecutive duplicates, giving {1,2,1}, which has size 3."
 },
 {
  "id": 86,
  "category": "stl",
  "q": "What is the output?\nvector<int> v{5,1,4};\nsort(v.begin(), v.end(), greater<int>());\ncout << v[0] << v[2];",
  "options": [
   "54",
   "15",
   "51",
   "41"
  ],
  "correctIndex": 2,
  "explanation": "Sorted descending the vector is {5,4,1}, so v[0]=5 and v[2]=1, printing 51."
 },
 {
  "id": 87,
  "category": "stl",
  "q": "What is the output?\nmap<int,int> m;\nm.insert({1,10});\nm.insert({1,20});\ncout << m[1] << m.size();",
  "options": [
   "101",
   "201",
   "202",
   "102"
  ],
  "correctIndex": 0,
  "explanation": "insert does not overwrite an existing key, so the value stays 10 and the size is 1."
 },
 {
  "id": 88,
  "category": "stl",
  "q": "What is the time complexity of std::make_heap on a range of n elements?",
  "options": [
   "O(n)",
   "O(n log n)",
   "O(log n)",
   "O(n^2)"
  ],
  "correctIndex": 0,
  "explanation": "Bottom-up heap construction (Floyd's method) is O(n); the standard guarantees at most 3n comparisons."
 },
 {
  "id": 89,
  "category": "stl",
  "q": "What is the output?\nvector<int> v(2,7);\nv.resize(4);\ncout << v[3] << v.size();",
  "options": [
   "74",
   "04",
   "03",
   "Undefined behavior"
  ],
  "correctIndex": 1,
  "explanation": "resize value-initializes new int elements to 0, and the size becomes 4, so it prints 04."
 },
 {
  "id": 90,
  "category": "stl",
  "q": "What is printed?\nset<int,greater<int>> s{1,3,2};\ncout << *s.begin();",
  "options": [
   "1",
   "2",
   "3",
   "Compile error"
  ],
  "correctIndex": 2,
  "explanation": "With greater<int> the set is ordered descending, so begin() refers to the largest element, 3."
 },
 {
  "id": 91,
  "category": "stl",
  "q": "Which is the correct way to erase matching elements from a std::map while iterating over it with an iterator?",
  "options": [
   "m.erase(it); then ++it",
   "it = m.erase(it); when erasing, else ++it",
   "m.erase(it++) is undefined behavior",
   "Erasing during iteration is always safe"
  ],
  "correctIndex": 1,
  "explanation": "erase returns the iterator following the removed element; using the erased iterator afterward is undefined behavior."
 },
 {
  "id": 92,
  "category": "stl",
  "q": "For sorted vector<int> v{1,3,3,5}, what does this print?\ncout << (lower_bound(v.begin(),v.end(),4) - v.begin());",
  "options": [
   "2",
   "3",
   "4",
   "1"
  ],
  "correctIndex": 1,
  "explanation": "lower_bound returns the first element not less than 4, which is 5 at index 3."
 },
 {
  "id": 93,
  "category": "stl",
  "q": "What is printed?\nvector<int> v{1,2,3,4};\npartial_sum(v.begin(),v.end(),v.begin());\ncout << v[2] << v[3];",
  "options": [
   "610",
   "34",
   "36",
   "410"
  ],
  "correctIndex": 0,
  "explanation": "The prefix sums are {1,3,6,10}, so v[2]=6 and v[3]=10, printing 610. The output iterator may be the same as the input."
 },
 {
  "id": 94,
  "category": "stl",
  "q": "Which algorithm guarantees that elements comparing equal keep their original relative order?",
  "options": [
   "std::sort",
   "std::stable_sort",
   "std::partial_sort",
   "std::nth_element"
  ],
  "correctIndex": 1,
  "explanation": "std::stable_sort preserves the relative order of equivalent elements, whereas std::sort makes no such guarantee."
 },
 {
  "id": 95,
  "category": "stl",
  "q": "Which STL algorithm finds the k-th smallest element in average O(n) time without fully sorting the range?",
  "options": [
   "std::partial_sort",
   "std::sort",
   "std::nth_element",
   "std::lower_bound"
  ],
  "correctIndex": 2,
  "explanation": "nth_element uses a quickselect-style partition, giving average linear time and placing the k-th element in its sorted position."
 },
 {
  "id": 96,
  "category": "templates",
  "q": "For a type parameter, what is the difference between `template<class T>` and `template<typename T>`?",
  "options": [
   "`class` only accepts user-defined class types",
   "`typename` only accepts built-in types",
   "No difference; they are interchangeable for type parameters",
   "`typename` makes the template inline"
  ],
  "correctIndex": 2,
  "explanation": "In a template parameter list, `class` and `typename` are equivalent for declaring type parameters."
 },
 {
  "id": 97,
  "category": "templates",
  "q": "Given `template<typename T> T mx(T a, T b){return a>b?a:b;}`, what happens with `mx(3, 4.5)`?",
  "options": [
   "Returns 4.5 as double",
   "Returns 4 as int",
   "Compile error: conflicting deduction for T (int vs double)",
   "Undefined behavior at runtime"
  ],
  "correctIndex": 2,
  "explanation": "T is deduced as int from the first argument and double from the second, so deduction fails; no implicit conversion is considered."
 },
 {
  "id": 98,
  "category": "templates",
  "q": "What is the output?\n`template<typename T> void f(T){cout<<\"A\";}\ntemplate<> void f<int>(int){cout<<\"B\";}\nf(1); f(1.0);`",
  "options": [
   "AA",
   "BA",
   "AB",
   "BB"
  ],
  "correctIndex": 1,
  "explanation": "f(1) uses the int specialization (B); f(1.0) deduces double and uses the primary template (A)."
 },
 {
  "id": 99,
  "category": "templates",
  "q": "Output?\n`void f(int){cout<<\"N\";}\ntemplate<typename T> void f(T){cout<<\"T\";}\nf(5); f('a');`",
  "options": [
   "NN",
   "TT",
   "TN",
   "NT"
  ],
  "correctIndex": 3,
  "explanation": "f(5) is an exact match for both, so the non-template wins. f('a') is an exact match for the template with T=char, but the non-template needs a promotion, so the template wins."
 },
 {
  "id": 100,
  "category": "templates",
  "q": "Why are class and function template definitions usually placed in header files?",
  "options": [
   "The compiler needs the full definition at the point of instantiation",
   "Templates cannot have .cpp files by language rule",
   "Headers make templates run faster",
   "Linkers cannot link template code at all"
  ],
  "correctIndex": 0,
  "explanation": "The compiler must see the definition in each translation unit that instantiates the template, so it normally lives in the header."
 },
 {
  "id": 101,
  "category": "templates",
  "q": "Which statement about function templates in C++17 is true?",
  "options": [
   "They support both full and partial specialization",
   "They support partial specialization but not full",
   "They cannot be specialized at all",
   "They support full specialization but not partial; use overloading instead"
  ],
  "correctIndex": 3,
  "explanation": "Partial specialization of function templates is not allowed; overloading or tag dispatch is used instead."
 },
 {
  "id": 102,
  "category": "templates",
  "q": "Output?\n`template<typename T> struct C{static int n;};\ntemplate<typename T> int C<T>::n=0;\nC<int>::n++; C<int>::n++; C<double>::n++;\ncout<<C<int>::n<<C<double>::n;`",
  "options": [
   "21",
   "31",
   "12",
   "33"
  ],
  "correctIndex": 0,
  "explanation": "Each instantiation of a class template has its own static member: C<int>::n is 2 and C<double>::n is 1."
 },
 {
  "id": 103,
  "category": "templates",
  "q": "Output?\n`template<typename... A> auto sum(A... a){ return (a + ...); }\ncout << sum(1, 2, 3.5);`",
  "options": [
   "6",
   "6.5",
   "Compile error: mixed types",
   "3"
  ],
  "correctIndex": 1,
  "explanation": "The fold expression gives 1 + (2 + 3.5) = 6.5, and the deduced return type is double."
 },
 {
  "id": 104,
  "category": "templates",
  "q": "Why is `if constexpr` needed instead of `if` in `template<class T> auto g(T t){ if constexpr(is_pointer_v<T>) return *t; else return t; }`?",
  "options": [
   "Plain `if` is not allowed in templates",
   "It makes the condition evaluate at runtime",
   "It avoids the need for `return` statements",
   "The discarded branch is not instantiated, so `*t` isn't compiled for non-pointers"
  ],
  "correctIndex": 3,
  "explanation": "With a plain `if`, both branches must compile for every T, so `*t` fails for T=int. `if constexpr` discards the false branch at compile time."
 },
 {
  "id": 105,
  "category": "templates",
  "q": "In C++17, what does `std::pair p(1, 2.5);` declare, thanks to class template argument deduction (CTAD)?",
  "options": [
   "pair<double,double>",
   "pair<int,double>",
   "Compile error: template arguments missing",
   "pair<int,int>"
  ],
  "correctIndex": 1,
  "explanation": "C++17 CTAD deduces pair<int,double> from the constructor arguments."
 },
 {
  "id": 106,
  "category": "templates",
  "q": "In `template<typename T> void h(){ ___ T::value_type x; }` which keyword is required to declare x?",
  "options": [
   "typename",
   "class",
   "template",
   "auto&&"
  ],
  "correctIndex": 0,
  "explanation": "`T::value_type` is a dependent name, so `typename` is needed to tell the compiler it names a type."
 },
 {
  "id": 107,
  "category": "templates",
  "q": "Output?\n`template<typename T=int> struct S{ T v; };\nS<> s; s.v = 3.7; cout << s.v;`",
  "options": [
   "3.7",
   "Compile error: S<> invalid",
   "3",
   "4"
  ],
  "correctIndex": 2,
  "explanation": "S<> uses the default T=int, so assigning 3.7 truncates to 3."
 },
 {
  "id": 108,
  "category": "templates",
  "q": "Which can be used as a non-type template argument for `template<int N> struct A{};` in C++17?",
  "options": [
   "A runtime variable `int x`",
   "A constant expression like `4*2`",
   "A `std::string` object",
   "A `double` literal like 2.5"
  ],
  "correctIndex": 1,
  "explanation": "Non-type arguments must be compile-time constant expressions of the parameter's type; runtime values are not allowed."
 },
 {
  "id": 109,
  "category": "templates",
  "q": "What does SFINAE stand for and imply?",
  "options": [
   "Static Function Inlining And Name Expansion",
   "Single Failure In Allocation Never Errors",
   "Substitution Failure Is Not An Error: an invalid substitution removes that overload",
   "Safe Format Inference At Native Execution"
  ],
  "correctIndex": 2,
  "explanation": "If substituting template arguments into a signature yields invalid code, that candidate is dropped instead of causing a hard error."
 },
 {
  "id": 110,
  "category": "templates",
  "q": "What is `template<template<typename> class C, typename T> struct W{ C<T> c; };` an example of?",
  "options": [
   "Variadic template",
   "Template template parameter",
   "Partial specialization",
   "Explicit instantiation"
  ],
  "correctIndex": 1,
  "explanation": "`C` is itself a class template taking one type, which is a template template parameter."
 },
 {
  "id": 111,
  "category": "templates",
  "q": "For `template<typename T> void f(T&& x);` and `int a=0; f(a);`, what is T deduced as?",
  "options": [
   "int",
   "int&&",
   "const int",
   "int&"
  ],
  "correctIndex": 3,
  "explanation": "T&& is a forwarding reference. An lvalue deduces T=int&, and reference collapsing makes the parameter int&."
 },
 {
  "id": 112,
  "category": "templates",
  "q": "Output?\n`template<typename T,size_t N> size_t len(T(&)[N]){return N;}\nint a[5]; cout << len(a);`",
  "options": [
   "5",
   "1",
   "Size of pointer, e.g. 8",
   "Compile error"
  ],
  "correctIndex": 0,
  "explanation": "Taking the array by reference prevents decay, so N is deduced as 5."
 },
 {
  "id": 113,
  "category": "templates",
  "q": "When you instantiate a class template `Box<int>`, which member functions get instantiated?",
  "options": [
   "All member functions immediately",
   "Only the constructors and destructor",
   "Only virtual and static ones",
   "Only those that are actually used (implicit instantiation is lazy)"
  ],
  "correctIndex": 3,
  "explanation": "Non-virtual member functions of a class template are instantiated only when they are used."
 },
 {
  "id": 114,
  "category": "templates",
  "q": "Output?\n`template<class T> struct Tr{static const int v=0;};\ntemplate<> struct Tr<int>{static const int v=1;};\ntemplate<class T> struct Tr<T*>{static const int v=2;};\ncout<<Tr<double>::v<<Tr<int>::v<<Tr<int*>::v;`",
  "options": [
   "012",
   "021",
   "011",
   "010"
  ],
  "correctIndex": 0,
  "explanation": "double uses the primary (0), int uses the full specialization (1), and int* matches the pointer partial specialization (2)."
 },
 {
  "id": 115,
  "category": "templates",
  "q": "Given `template<typename T> void f(T& x);`, what happens with the call `f(5);`?",
  "options": [
   "Compiles with T=int and binds to a temporary",
   "Compiles with T=const int",
   "Compile error: a non-const lvalue reference cannot bind to an rvalue",
   "Runtime error"
  ],
  "correctIndex": 2,
  "explanation": "T is deduced as int, so the parameter is int&, which cannot bind to the rvalue 5. Only a `const T&` or `T&&` parameter would accept it."
 },
 {
  "id": 116,
  "category": "memory",
  "q": "Which C++11/17 smart pointer models exclusive (single-owner) ownership of a heap object and is non-copyable?",
  "options": [
   "std::shared_ptr",
   "std::unique_ptr",
   "std::weak_ptr",
   "std::auto_ptr"
  ],
  "correctIndex": 1,
  "explanation": "unique_ptr has exactly one owner; its copy operations are deleted and it can only be moved."
 },
 {
  "id": 117,
  "category": "memory",
  "q": "What happens?\nauto a = std::make_unique<int>(5);\nstd::unique_ptr<int> b = a;",
  "options": [
   "b shares ownership with a",
   "a becomes null and b owns the int",
   "Compile-time error: copy constructor is deleted",
   "Runtime exception std::bad_alloc"
  ],
  "correctIndex": 2,
  "explanation": "unique_ptr's copy constructor is deleted, so the copy fails to compile; std::move(a) would be required."
 },
 {
  "id": 118,
  "category": "memory",
  "q": "What is printed?\nauto p = std::make_shared<int>(1);\nauto q = p;\n{ auto r = p; }\nstd::cout << p.use_count();",
  "options": [
   "1",
   "2",
   "3",
   "0"
  ],
  "correctIndex": 1,
  "explanation": "p and q own the object; r was destroyed at the end of the inner block, so the count is 2."
 },
 {
  "id": 119,
  "category": "memory",
  "q": "What is the primary purpose of std::weak_ptr?",
  "options": [
   "Faster alternative to shared_ptr",
   "Own an array of objects",
   "Automatically delete objects after a timeout",
   "Observe a shared_ptr-managed object without owning it, breaking cycles"
  ],
  "correctIndex": 3,
  "explanation": "weak_ptr does not increase the strong count, so it prevents cyclic shared_ptr leaks and lets you check validity via lock()."
 },
 {
  "id": 120,
  "category": "memory",
  "q": "What is the output?\nauto a = std::make_unique<int>(7);\nauto b = std::move(a);\nstd::cout << (a == nullptr) << *b;",
  "options": [
   "17",
   "07",
   "Undefined behavior",
   "Compile error"
  ],
  "correctIndex": 0,
  "explanation": "After the move, a is null (prints 1) and b holds 7, so the output is 17."
 },
 {
  "id": 121,
  "category": "memory",
  "q": "What is the status of this code?\nint* p = new int[5];\ndelete p;",
  "options": [
   "Well-defined; frees all 5 ints",
   "Compile error",
   "Undefined behavior; delete[] must be used",
   "Frees only the first int, the rest leak safely"
  ],
  "correctIndex": 2,
  "explanation": "Memory from new[] must be released with delete[]; mismatched delete is undefined behavior."
 },
 {
  "id": 122,
  "category": "memory",
  "q": "void f(){ int* p = new int(5); throw std::runtime_error(\"x\"); }\nIf the exception is caught by the caller, what happens to the int?",
  "options": [
   "It is freed during stack unwinding",
   "It is leaked",
   "It is freed by the garbage collector",
   "It is moved to the caller's stack"
  ],
  "correctIndex": 1,
  "explanation": "Raw pointers have no destructor that frees memory, so the allocation leaks; a unique_ptr would prevent this (RAII)."
 },
 {
  "id": 123,
  "category": "memory",
  "q": "What is printed?\nstd::weak_ptr<int> w;\n{ auto s = std::make_shared<int>(3); w = s; }\nstd::cout << w.expired();",
  "options": [
   "0",
   "1",
   "3",
   "Undefined behavior"
  ],
  "correctIndex": 1,
  "explanation": "The only shared_ptr died at the end of the block, so the weak_ptr is expired and expired() returns true (1)."
 },
 {
  "id": 124,
  "category": "memory",
  "q": "On a typical 64-bit implementation, sizeof(std::unique_ptr<int>) with the default deleter is:",
  "options": [
   "8 bytes, same as a raw pointer",
   "16 bytes",
   "24 bytes",
   "32 bytes"
  ],
  "correctIndex": 0,
  "explanation": "With an empty default deleter (empty base optimization), unique_ptr has zero overhead over a raw pointer."
 },
 {
  "id": 125,
  "category": "memory",
  "q": "What is a key advantage of std::make_shared<T>() over std::shared_ptr<T>(new T)?",
  "options": [
   "It allows custom deleters",
   "It works with arrays only",
   "It makes the object thread-safe",
   "It allocates the object and control block in one allocation"
  ],
  "correctIndex": 3,
  "explanation": "make_shared does a single allocation, which is more efficient and also exception-safe in function arguments."
 },
 {
  "id": 126,
  "category": "memory",
  "q": "What is the problem?\nint* raw = new int(10);\nstd::shared_ptr<int> a(raw);\nstd::shared_ptr<int> b(raw);",
  "options": [
   "Double delete: two independent control blocks free the same memory",
   "None; use_count will be 2",
   "Compile error",
   "Memory leak only"
  ],
  "correctIndex": 0,
  "explanation": "Each shared_ptr built from the raw pointer creates its own control block, so both delete raw: undefined behavior."
 },
 {
  "id": 127,
  "category": "memory",
  "q": "Why would a class derive from std::enable_shared_from_this<T>?",
  "options": [
   "To make its objects copy-free",
   "To safely obtain a shared_ptr to this that shares the existing control block",
   "To allocate itself on the stack",
   "To disable reference counting"
  ],
  "correctIndex": 1,
  "explanation": "shared_from_this() returns a shared_ptr sharing ownership with existing owners, avoiding multiple control blocks."
 },
 {
  "id": 128,
  "category": "memory",
  "q": "class Buf { int* d; public: Buf():d(new int[10]){} ~Buf(){delete[] d;} };\nBuf a; Buf b = a;\nWhat is the issue?",
  "options": [
   "Compiler refuses to copy",
   "Shallow copy causes double delete[] (Rule of Three violation)",
   "b gets a deep copy automatically",
   "Only a memory leak occurs"
  ],
  "correctIndex": 1,
  "explanation": "The implicit copy constructor copies the pointer, so both destructors free the same array: undefined behavior."
 },
 {
  "id": 129,
  "category": "memory",
  "q": "After constructing an object using placement new into a buffer, what must you do before reusing or releasing the buffer?",
  "options": [
   "Call delete on the object",
   "Call free() on the object",
   "Nothing; destruction is automatic",
   "Explicitly call the object's destructor"
  ],
  "correctIndex": 3,
  "explanation": "Placement new only constructs; you must call obj->~T() manually, and the buffer is released by its own owner."
 },
 {
  "id": 130,
  "category": "memory",
  "q": "Which correctly manages a dynamically allocated array of 3 ints with a smart pointer in C++17?",
  "options": [
   "std::unique_ptr<int> p(new int[3]);",
   "std::shared_ptr<int> p(new int[3]);",
   "std::unique_ptr<int[]> p(new int[3]);",
   "std::weak_ptr<int[]> p(new int[3]);"
  ],
  "correctIndex": 2,
  "explanation": "unique_ptr<T[]> uses delete[]; the other first two options call delete (UB), and weak_ptr cannot own."
 },
 {
  "id": 131,
  "category": "memory",
  "q": "Which statement about custom deleters is true?",
  "options": [
   "Deleter type is part of unique_ptr's type but not of shared_ptr's type",
   "Deleter type is part of both types",
   "Deleter type is part of neither type",
   "Deleter type is part of shared_ptr's type only"
  ],
  "correctIndex": 0,
  "explanation": "unique_ptr<T,D> encodes D in its type; shared_ptr type-erases the deleter in its control block."
 },
 {
  "id": 132,
  "category": "memory",
  "q": "What is printed?\nstruct A{ A(){std::cout<<\"C\";} ~A(){std::cout<<\"D\";} };\nint main(){ auto p=std::make_unique<A>(); p.reset(); std::cout<<\"X\"; }",
  "options": [
   "CXD",
   "CDX",
   "CD",
   "DCX"
  ],
  "correctIndex": 1,
  "explanation": "reset() destroys the object immediately, so D prints before X."
 },
 {
  "id": 133,
  "category": "memory",
  "q": "What is printed? (A prints C in ctor and D in dtor)\nauto p=std::make_shared<A>();\nauto q=p;\np.reset(); std::cout<<\"X\";\nq.reset(); std::cout<<\"Y\";",
  "options": [
   "CDXY",
   "CXYD",
   "CXDY",
   "CDYX"
  ],
  "correctIndex": 2,
  "explanation": "Object is destroyed only when the last owner q resets, giving C, X, D, Y."
 },
 {
  "id": 134,
  "category": "memory",
  "q": "std::vector<int> v(3);\nint* p = &v[0];\nv.push_back(1);\nstd::cout << *p;\nWhat is the result?",
  "options": [
   "Always prints 0",
   "Always prints 1",
   "Compile error",
   "Undefined behavior; reallocation invalidated p"
  ],
  "correctIndex": 3,
  "explanation": "Size equals capacity (3), so push_back reallocates and p dangles; dereferencing it is undefined behavior."
 },
 {
  "id": 135,
  "category": "memory",
  "q": "For the statement int* p = new int(4); inside a function, where are p and the int it points to stored?",
  "options": [
   "Both on the heap",
   "p on the stack, the int on the heap",
   "p on the heap, the int on the stack",
   "Both in the data segment"
  ],
  "correctIndex": 1,
  "explanation": "The local pointer variable has automatic storage (stack), while new allocates the int on the free store (heap)."
 },
 {
  "id": 136,
  "category": "modern",
  "q": "In C++17, what is the deduced type of x in `auto x = {1, 2, 3};`?",
  "options": [
   "std::vector<int>",
   "std::initializer_list<int>",
   "int[3]",
   "Compile error"
  ],
  "correctIndex": 1,
  "explanation": "With copy-list-initialization, auto deduces std::initializer_list<int>."
 },
 {
  "id": 137,
  "category": "modern",
  "q": "What does std::move(x) actually do?",
  "options": [
   "Moves x's data into a new object immediately",
   "Deletes x and frees its memory",
   "Casts x to an rvalue reference",
   "Copies x and then clears it"
  ],
  "correctIndex": 2,
  "explanation": "std::move is only a static_cast to T&&. The move happens when a move constructor or assignment is invoked."
 },
 {
  "id": 138,
  "category": "modern",
  "q": "What happens here?\n`auto a = std::make_unique<int>(5); auto b = a;`",
  "options": [
   "Compile error: unique_ptr copy constructor is deleted",
   "b shares ownership with a",
   "a becomes nullptr and b owns the int",
   "Runtime double free"
  ],
  "correctIndex": 0,
  "explanation": "unique_ptr is move-only, so copying is ill-formed. You must write std::move(a)."
 },
 {
  "id": 139,
  "category": "modern",
  "q": "Which is allowed in a constexpr function from C++14 but NOT in C++11?",
  "options": [
   "A return statement",
   "Calling another constexpr function",
   "Taking parameters by value",
   "Loops and multiple statements with local variables"
  ],
  "correctIndex": 3,
  "explanation": "C++11 constexpr functions had to be a single return expression. C++14 relaxed this to allow loops, locals and branches."
 },
 {
  "id": 140,
  "category": "modern",
  "q": "For `std::map<int,std::string> m;`, what is the type of k in `for (auto& [k, v] : m)`?",
  "options": [
   "int",
   "const int",
   "int&",
   "std::pair<int,std::string>"
  ],
  "correctIndex": 1,
  "explanation": "The map's value_type is pair<const int, string>, so k refers to a const int."
 },
 {
  "id": 141,
  "category": "modern",
  "q": "Output?\n`int x=1; auto f=[x]() mutable {return ++x;};\nf(); std::cout<<f()<<x;`",
  "options": [
   "22",
   "31",
   "21",
   "32"
  ],
  "correctIndex": 1,
  "explanation": "The mutable lambda increments its own copy: the first call gives 2, the second gives 3. The outer x stays 1, so the output is 31."
 },
 {
  "id": 142,
  "category": "modern",
  "q": "What does calling value() on an empty std::optional<int> do?",
  "options": [
   "Returns 0",
   "Undefined behavior",
   "Throws std::bad_optional_access",
   "Returns a garbage value silently"
  ],
  "correctIndex": 2,
  "explanation": "value() throws std::bad_optional_access. operator* on an empty optional is UB."
 },
 {
  "id": 143,
  "category": "modern",
  "q": "Output?\n`std::variant<int,double> v; std::cout << v.index();`",
  "options": [
   "0",
   "1",
   "-1",
   "Compile error"
  ],
  "correctIndex": 0,
  "explanation": "A default-constructed variant holds a value-initialized first alternative (int 0), so index() is 0."
 },
 {
  "id": 144,
  "category": "modern",
  "q": "What is the key effect of `if constexpr` inside a template?",
  "options": [
   "The condition is evaluated at runtime but faster",
   "The discarded branch is not instantiated for that specialization",
   "It forces the function to be inline",
   "It makes all branches compile and run"
  ],
  "correctIndex": 1,
  "explanation": "The false branch is discarded at compile time and not instantiated, so it can contain code invalid for that type."
 },
 {
  "id": 145,
  "category": "modern",
  "q": "Base has `virtual void f() const;`. Derived declares `void f() override;`. What happens?",
  "options": [
   "Compiles and overrides Base::f",
   "Compile error: no matching virtual function to override",
   "Compiles; Derived::f hides Base::f silently",
   "Undefined behavior at runtime"
  ],
  "correctIndex": 1,
  "explanation": "The signatures differ in const-ness, so override fails to match and the compiler reports an error."
 },
 {
  "id": 146,
  "category": "modern",
  "q": "Output?\n`auto a=std::make_shared<int>(1); auto b=a;\nauto c=std::move(a);\nstd::cout<<a.use_count()<<b.use_count();`",
  "options": [
   "22",
   "12",
   "03",
   "02"
  ],
  "correctIndex": 3,
  "explanation": "Moving from a leaves it empty, so its count is 0. b and c share ownership, so b.use_count() is 2."
 },
 {
  "id": 147,
  "category": "modern",
  "q": "Why should a move constructor be marked noexcept for use with std::vector?",
  "options": [
   "Otherwise it cannot be defined",
   "vector reallocation uses move only if it is noexcept (or no copy exists), else it copies",
   "noexcept makes moves faster at runtime by itself",
   "vector forbids throwing types"
  ],
  "correctIndex": 1,
  "explanation": "vector uses std::move_if_noexcept to keep its strong exception guarantee, so a throwing move falls back to copying."
 },
 {
  "id": 148,
  "category": "modern",
  "q": "What is wrong with this?\n`std::string_view sv = std::string(\"hello\"); std::cout << sv;`",
  "options": [
   "Nothing, it is valid",
   "Compile error: string_view cannot bind to a string",
   "sv dangles because the temporary string is destroyed, so it is UB",
   "string_view copies the data, but is slow"
  ],
  "correctIndex": 2,
  "explanation": "string_view does not own its data. The temporary dies at the end of the statement, leaving sv dangling."
 },
 {
  "id": 149,
  "category": "modern",
  "q": "Given `int x=0; decltype(auto) y = (x);` what is the type of y?",
  "options": [
   "int",
   "const int",
   "int&&",
   "int&"
  ],
  "correctIndex": 3,
  "explanation": "decltype((x)) for an lvalue expression gives int&. decltype(auto) applies decltype rules, so y is int&."
 },
 {
  "id": 150,
  "category": "modern",
  "q": "A class declares a user-defined destructor but no move operations. What happens when you std::move an object of it?",
  "options": [
   "A move constructor is generated automatically",
   "Compile error",
   "The copy constructor is used instead",
   "The object is left in a null state"
  ],
  "correctIndex": 2,
  "explanation": "A user-declared destructor suppresses the implicit move operations, so rvalues bind to the copy constructor."
 },
 {
  "id": 151,
  "category": "modern",
  "q": "Which standard introduced std::make_unique?",
  "options": [
   "C++11",
   "C++14",
   "C++17",
   "C++20"
  ],
  "correctIndex": 1,
  "explanation": "make_shared arrived in C++11, but make_unique was added in C++14."
 },
 {
  "id": 152,
  "category": "modern",
  "q": "For `template<class T> void f(T&& x);` and `int a; f(a);`, what is T deduced as?",
  "options": [
   "int",
   "int&&",
   "const int",
   "int&"
  ],
  "correctIndex": 3,
  "explanation": "T&& is a forwarding reference. An lvalue argument makes T = int&, and reference collapsing gives int&."
 },
 {
  "id": 153,
  "category": "modern",
  "q": "Output?\n`int a[]={1,2,3}; for(auto x : a) x*=2; std::cout<<a[0];`",
  "options": [
   "1",
   "2",
   "6",
   "Compile error"
  ],
  "correctIndex": 0,
  "explanation": "auto x copies each element, so the array is unchanged. You would need auto& to modify it."
 },
 {
  "id": 154,
  "category": "modern",
  "q": "What is std::scoped_lock (C++17) mainly used for?",
  "options": [
   "Locking several mutexes at once without deadlock, with RAII release",
   "Making a variable thread_local",
   "Running a function asynchronously",
   "Creating a reader-writer lock"
  ],
  "correctIndex": 0,
  "explanation": "scoped_lock acquires multiple mutexes using a deadlock-avoidance algorithm and releases them on scope exit."
 },
 {
  "id": 155,
  "category": "modern",
  "q": "Value returned?\n`template<class... T> auto f(T... a){ return (a - ...); }`\n`f(10, 2, 3)`",
  "options": [
   "5",
   "11",
   "-15",
   "Compile error"
  ],
  "correctIndex": 1,
  "explanation": "(a - ...) is a right fold, so it computes 10 - (2 - 3) = 11. A left fold would give 5."
 },
 {
  "id": 156,
  "category": "exceptions",
  "q": "What does the C++ idiom RAII stand for, and what is its core idea?",
  "options": [
   "Run-time Allocation Is Immediate; allocate memory on the heap only",
   "Resource Allocation Is Interrupt-safe; disable interrupts while allocating",
   "Resource Acquisition Is Initialization; resource lifetime is tied to object lifetime",
   "Reference Access Is Immutable; objects are never modified after construction"
  ],
  "correctIndex": 2,
  "explanation": "RAII acquires resources in a constructor and releases them in the destructor, so cleanup is automatic, even during exceptions."
 },
 {
  "id": 157,
  "category": "exceptions",
  "q": "Output?\nstruct A{A(){cout<<\"A\";} ~A(){cout<<\"~A\";}};\nint main(){ try{ A a; throw 1; } catch(int){ cout<<\"C\"; } }",
  "options": [
   "A~AC",
   "AC~A",
   "AC",
   "A~A"
  ],
  "correctIndex": 0,
  "explanation": "Stack unwinding destroys the local a before the handler runs, so the output is A, ~A, then C."
 },
 {
  "id": 158,
  "category": "exceptions",
  "q": "In C++17, a destructor with no explicit exception specification throws an exception that escapes it. What happens?",
  "options": [
   "The exception propagates normally to the nearest matching catch",
   "std::terminate is called, because destructors are implicitly noexcept",
   "The exception is silently swallowed and execution continues",
   "Compilation fails with an error"
  ],
  "correctIndex": 1,
  "explanation": "Destructors are implicitly noexcept(true) unless declared noexcept(false), so an escaping exception calls std::terminate."
 },
 {
  "id": 159,
  "category": "exceptions",
  "q": "Output?\ntry{ throw std::runtime_error(\"x\"); }\ncatch(std::exception&){ cout<<\"E\"; }\ncatch(std::runtime_error&){ cout<<\"R\"; }",
  "options": [
   "R",
   "ER",
   "Compile error because the second handler is unreachable",
   "E"
  ],
  "correctIndex": 3,
  "explanation": "Handlers are tried in order, and std::exception& matches first. The second handler is unreachable, though it only draws a warning."
 },
 {
  "id": 160,
  "category": "exceptions",
  "q": "Output?\nstruct B{virtual const char* w(){return \"B\";}};\nstruct D:B{const char* w() override{return \"D\";}};\ntry{ throw D(); } catch(B b){ cout<<b.w(); }",
  "options": [
   "D",
   "Compile error",
   "B",
   "Undefined behavior"
  ],
  "correctIndex": 2,
  "explanation": "Catching by value slices the D object into a B, so the virtual call resolves to B::w. Catch by reference to avoid this."
 },
 {
  "id": 161,
  "category": "exceptions",
  "q": "Inside catch(std::exception& e), what is the difference between `throw;` and `throw e;`?",
  "options": [
   "`throw;` rethrows the original object; `throw e;` throws a sliced copy of static type std::exception",
   "Both are identical in behavior",
   "`throw;` creates a copy; `throw e;` rethrows the original object",
   "`throw;` is illegal inside a catch block"
  ],
  "correctIndex": 0,
  "explanation": "A bare `throw;` rethrows the current exception object and preserves its dynamic type. `throw e;` copy-initializes a new exception from e's static type."
 },
 {
  "id": 162,
  "category": "exceptions",
  "q": "A constructor throws after member `std::vector<int> v` was fully constructed but before the constructor body finished. What happens?",
  "options": [
   "The class destructor runs, then v is destroyed",
   "v is destroyed, but the class's own destructor does not run",
   "Neither runs, so v leaks",
   "Both run only if the constructor is declared noexcept"
  ],
  "correctIndex": 1,
  "explanation": "Fully constructed members and bases are destroyed during unwinding, but the destructor of the incompletely constructed object is not called."
 },
 {
  "id": 163,
  "category": "exceptions",
  "q": "Output?\nvoid f() noexcept { throw 1; }\nint main(){ try{ f(); } catch(...){ cout<<\"C\"; } }",
  "options": [
   "C",
   "Nothing; the exception is ignored",
   "Compile error",
   "std::terminate is called, and C is not printed"
  ],
  "correctIndex": 3,
  "explanation": "An exception escaping a noexcept function calls std::terminate, so the catch(...) in the caller never runs."
 },
 {
  "id": 164,
  "category": "exceptions",
  "q": "Output?\nstruct G{int i; G(int i):i(i){} ~G(){cout<<i;}};\nvoid f(){ G a(1); G b(2); throw 0; }\nint main(){ try{ f(); } catch(...){ cout<<9; } }",
  "options": [
   "219",
   "129",
   "921",
   "192"
  ],
  "correctIndex": 0,
  "explanation": "Locals are destroyed in reverse order of construction (b then a), and then the handler prints 9, giving 219."
 },
 {
  "id": 165,
  "category": "exceptions",
  "q": "What is the bug in `void f(){ std::lock_guard<std::mutex>{m}; /* critical section */ }`?",
  "options": [
   "lock_guard cannot be used with std::mutex",
   "It deadlocks, because the mutex is locked twice",
   "The temporary is destroyed at the semicolon, so the mutex is unlocked before the critical section",
   "It leaks the mutex because lock_guard has no destructor"
  ],
  "correctIndex": 2,
  "explanation": "The unnamed temporary lock_guard locks and then unlocks at the end of the statement, so the critical section is unprotected. Name the object instead."
 },
 {
  "id": 166,
  "category": "concurrency",
  "q": "What happens if a joinable std::thread object is destroyed without join() or detach() having been called?",
  "options": [
   "It is joined automatically",
   "It is detached automatically",
   "std::terminate is called",
   "The thread is silently cancelled"
  ],
  "correctIndex": 2,
  "explanation": "The std::thread destructor calls std::terminate if the thread is still joinable, so you must join or detach first."
 },
 {
  "id": 167,
  "category": "concurrency",
  "q": "Which lock wrapper must you pass to std::condition_variable::wait()?",
  "options": [
   "std::lock_guard<std::mutex>",
   "std::unique_lock<std::mutex>",
   "std::scoped_lock<std::mutex>",
   "A raw std::mutex reference"
  ],
  "correctIndex": 1,
  "explanation": "wait() must unlock and relock the mutex, so it needs std::unique_lock, which supports unlock()/lock(); lock_guard does not."
 },
 {
  "id": 168,
  "category": "concurrency",
  "q": "Two threads each run 'for(int i=0;i<1000;i++) counter++;' on a shared plain int counter with no synchronization. What is the outcome?",
  "options": [
   "Always exactly 2000",
   "Always less than 2000",
   "Compile-time error",
   "Undefined behavior due to a data race"
  ],
  "correctIndex": 3,
  "explanation": "Unsynchronized concurrent writes to a non-atomic variable are a data race, which is undefined behavior; the result is not just 'sometimes less'."
 },
 {
  "id": 169,
  "category": "concurrency",
  "q": "Output of: std::async(std::launch::async, []{ std::this_thread::sleep_for(std::chrono::seconds(1)); std::cout<<\"B\"; });\nstd::cout<<\"A\";",
  "options": [
   "BA",
   "AB",
   "A only",
   "Output order is unspecified"
  ],
  "correctIndex": 0,
  "explanation": "The discarded temporary future from std::async(launch::async) blocks in its destructor until the task finishes, so B prints before A."
 },
 {
  "id": 170,
  "category": "concurrency",
  "q": "What is the main purpose of C++17 std::scoped_lock when constructed as std::scoped_lock lk(m1, m2);?",
  "options": [
   "Lock m1 and m2 in the given order only",
   "Allow m1 and m2 to be locked by many readers",
   "Lock both mutexes using a deadlock-avoidance algorithm",
   "Lock the mutexes without blocking"
  ],
  "correctIndex": 2,
  "explanation": "scoped_lock locks multiple mutexes as if by std::lock, avoiding deadlock from inconsistent lock ordering, and releases them via RAII."
 },
 {
  "id": 171,
  "category": "concurrency",
  "q": "Why should condition_variable::wait be used with a predicate (or in a while loop checking the condition)?",
  "options": [
   "To make notify_one faster",
   "To avoid needing a mutex",
   "To make the wait time out automatically",
   "To guard against spurious wakeups and lost notifications"
  ],
  "correctIndex": 3,
  "explanation": "A waiting thread can wake without a notification, so the condition must be rechecked; a predicate overload does this loop internally."
 },
 {
  "id": 172,
  "category": "concurrency",
  "q": "What does std::memory_order_relaxed guarantee for an atomic operation?",
  "options": [
   "Sequential consistency across all threads",
   "Atomicity only, with no ordering of surrounding memory accesses",
   "Acquire semantics on loads only",
   "That the operation is lock-free"
  ],
  "correctIndex": 1,
  "explanation": "Relaxed operations are atomic and respect modification order of that variable, but impose no inter-thread ordering on other reads or writes."
 },
 {
  "id": 173,
  "category": "concurrency",
  "q": "In C++17, which combination is correct for a read-mostly shared data structure protected by std::shared_mutex?",
  "options": [
   "shared_lock for readers, unique_lock for writers",
   "unique_lock for readers, shared_lock for writers",
   "shared_lock for both readers and writers",
   "lock_guard for readers, shared_lock for writers"
  ],
  "correctIndex": 0,
  "explanation": "shared_lock takes shared ownership so many readers run concurrently; unique_lock takes exclusive ownership for writers."
 },
 {
  "id": 174,
  "category": "concurrency",
  "q": "Which statement about 'int& get(){ static int x = compute(); return x; }' is true in C++11 and later?",
  "options": [
   "Initialization of x is not thread-safe without a mutex",
   "Initialization of x runs once per calling thread",
   "Initialization of x is thread-safe and happens exactly once",
   "It compiles only if x is declared atomic"
  ],
  "correctIndex": 2,
  "explanation": "Since C++11 'magic statics' guarantee a function-local static is initialized exactly once even with concurrent callers; later use of x still needs its own sync."
 },
 {
  "id": 175,
  "category": "concurrency",
  "q": "Given 'void inc(int& x){ ++x; }\nint n=0;\nstd::thread t(inc, n);\nt.join();' what is the result?",
  "options": [
   "Compiles; n becomes 1",
   "Compiles; n stays 0",
   "Compile error, since arguments are copied and cannot bind to int& without std::ref",
   "Compiles but calls std::terminate at runtime"
  ],
  "correctIndex": 2,
  "explanation": "std::thread decay-copies its arguments and passes them as rvalues, which cannot bind to int&; use std::ref(n) to pass by reference."
 },
 {
  "id": 176,
  "category": "dsa-core",
  "q": "What is the amortized time complexity of std::vector<int>::push_back in C++17?",
  "options": [
   "O(n)",
   "O(log n)",
   "O(1)",
   "O(n log n)"
  ],
  "correctIndex": 2,
  "explanation": "Capacity grows geometrically, so reallocation cost is spread out and push_back is amortized O(1)."
 },
 {
  "id": 177,
  "category": "dsa-core",
  "q": "What is the output?\nint a[] = {1,2,3,4,5};\ncout << sizeof(a)/sizeof(a[0]);",
  "options": [
   "20",
   "5",
   "4",
   "Compile error"
  ],
  "correctIndex": 1,
  "explanation": "sizeof(a) is the total bytes of the array and sizeof(a[0]) is one element, so the quotient is the element count, 5."
 },
 {
  "id": 178,
  "category": "dsa-core",
  "q": "Given a sorted array, which approach finds a pair with sum = target in O(n) time and O(1) extra space?",
  "options": [
   "Two pointers from both ends",
   "Hash set of seen values",
   "Nested loops",
   "Sort then binary search for each element"
  ],
  "correctIndex": 0,
  "explanation": "Move the left pointer up if the sum is too small and the right pointer down if too large; each element is visited once."
 },
 {
  "id": 179,
  "category": "dsa-core",
  "q": "What is the output?\nstring s = \"hello\";\ns.erase(1, 2);\ncout << s;",
  "options": [
   "hlo",
   "hllo",
   "heo",
   "lo"
  ],
  "correctIndex": 0,
  "explanation": "erase(pos, len) removes 2 characters starting at index 1 (\"el\"), leaving \"hlo\"."
 },
 {
  "id": 180,
  "category": "dsa-core",
  "q": "What does Kadane's algorithm return as the maximum subarray sum for {-2,1,-3,4,-1,2,1,-5,4}?",
  "options": [
   "7",
   "5",
   "4",
   "6"
  ],
  "correctIndex": 3,
  "explanation": "The subarray {4,-1,2,1} has the maximum sum, 6."
 },
 {
  "id": 181,
  "category": "dsa-core",
  "q": "What is the output?\nvector<int> v(5, 2);\nv.resize(3);\ncout << v.size() << v[2];",
  "options": [
   "52",
   "32",
   "33",
   "Undefined behavior"
  ],
  "correctIndex": 1,
  "explanation": "resize(3) shrinks the vector to 3 elements, all still 2, so it prints 3 then 2."
 },
 {
  "id": 182,
  "category": "dsa-core",
  "q": "When are iterators and references into a std::vector guaranteed to be invalidated by push_back?",
  "options": [
   "Always",
   "Never",
   "Only when reallocation occurs",
   "Only for the end() iterator"
  ],
  "correctIndex": 2,
  "explanation": "If size exceeds capacity, the buffer is reallocated and all iterators and references are invalidated; otherwise only end() is."
 },
 {
  "id": 183,
  "category": "dsa-core",
  "q": "Which method detects a cycle in a singly linked list using O(1) extra space?",
  "options": [
   "Floyd's slow/fast pointers",
   "Storing visited nodes in unordered_set",
   "Recursion with a depth counter",
   "Sorting the nodes by address"
  ],
  "correctIndex": 0,
  "explanation": "Floyd's tortoise-and-hare meet inside a cycle if one exists, and it needs only two pointers."
 },
 {
  "id": 184,
  "category": "dsa-core",
  "q": "For std::list<int>, inserting an element at a position given by an iterator has what time complexity?",
  "options": [
   "O(1)",
   "O(n)",
   "O(log n)",
   "O(n log n)"
  ],
  "correctIndex": 0,
  "explanation": "A doubly linked list only relinks neighboring nodes, so insertion at a known iterator is O(1)."
 },
 {
  "id": 185,
  "category": "dsa-core",
  "q": "What is the space complexity of reversing a singly linked list iteratively with prev, curr and next pointers?",
  "options": [
   "O(n)",
   "O(log n)",
   "O(n^2)",
   "O(1)"
  ],
  "correctIndex": 3,
  "explanation": "Only three pointers are used and the links are reversed in place."
 },
 {
  "id": 186,
  "category": "dsa-core",
  "q": "What is the output?\nstring a=\"abc\", b=\"abd\";\ncout << (a<b) << (a==\"abc\");",
  "options": [
   "00",
   "10",
   "11",
   "01"
  ],
  "correctIndex": 2,
  "explanation": "Lexicographically \"abc\" < \"abd\" is true (1), and a==\"abc\" is also true (1)."
 },
 {
  "id": 187,
  "category": "dsa-core",
  "q": "What is the output?\nint a[5] = {1,2};\ncout << a[1] + a[4];",
  "options": [
   "2",
   "Garbage value",
   "6",
   "Compile error"
  ],
  "correctIndex": 0,
  "explanation": "Remaining elements are value-initialized to 0, so a[1]+a[4] = 2+0 = 2."
 },
 {
  "id": 188,
  "category": "dsa-core",
  "q": "What is the time complexity of the sliding window maximum problem when solved with a monotonic deque?",
  "options": [
   "O(n log k)",
   "O(nk)",
   "O(n)",
   "O(n^2)"
  ],
  "correctIndex": 2,
  "explanation": "Each index is pushed to and popped from the deque at most once, so the total is O(n)."
 },
 {
  "id": 189,
  "category": "dsa-core",
  "q": "To find the missing number in an array holding 1..n with one value missing, which method avoids integer overflow for large n?",
  "options": [
   "Sum formula n(n+1)/2 minus sum",
   "XOR of all indices and elements",
   "Multiplying all values",
   "Sorting and summing"
  ],
  "correctIndex": 1,
  "explanation": "XOR never overflows, whereas the sum formula can overflow a 32-bit int for large n."
 },
 {
  "id": 190,
  "category": "dsa-core",
  "q": "What is the output?\nchar s[] = \"abc\";\ncout << sizeof(s) << strlen(s);",
  "options": [
   "33",
   "44",
   "34",
   "43"
  ],
  "correctIndex": 3,
  "explanation": "sizeof(s) counts the terminating '\\0' (4 bytes), while strlen(s) excludes it (3)."
 },
 {
  "id": 191,
  "category": "dsa-core",
  "q": "The Dutch National Flag algorithm sorts an array of 0s, 1s and 2s with what complexity?",
  "options": [
   "O(n) time, O(1) space",
   "O(n log n) time, O(1) space",
   "O(n) time, O(n) space",
   "O(n^2) time, O(1) space"
  ],
  "correctIndex": 0,
  "explanation": "Three pointers (low, mid, high) partition the array in a single pass without extra memory."
 },
 {
  "id": 192,
  "category": "dsa-core",
  "q": "What is the output?\nvector<int> v={1,2,3,4};\nv.erase(v.begin()+1);\ncout << v[1] << v.size();",
  "options": [
   "23",
   "24",
   "34",
   "33"
  ],
  "correctIndex": 3,
  "explanation": "After erasing 2 the vector is {1,3,4}, so v[1]=3 and size=3."
 },
 {
  "id": 193,
  "category": "dsa-core",
  "q": "Longest substring without repeating characters can be solved optimally in what time using a sliding window and a last-seen table?",
  "options": [
   "O(n^2)",
   "O(n)",
   "O(n log n)",
   "O(2^n)"
  ],
  "correctIndex": 1,
  "explanation": "Each character is processed once while the left pointer only moves forward, giving O(n)."
 },
 {
  "id": 194,
  "category": "dsa-core",
  "q": "Which sequence rotates an array of size n right by k in place in O(n) time and O(1) space?",
  "options": [
   "Reverse the whole array, then reverse the first k and the last n-k",
   "Copy to a temp array and shift",
   "Swap adjacent elements k times",
   "Sort the array, then reverse it"
  ],
  "correctIndex": 0,
  "explanation": "Reversing the whole array and then each of the two parts yields the right rotation in place."
 },
 {
  "id": 195,
  "category": "dsa-core",
  "q": "What happens?\nstring s = \"\";\nfor (size_t i = 0; i < s.size()-1; i++) cout << s[i];",
  "options": [
   "Prints nothing and exits",
   "Compile error",
   "Throws std::out_of_range",
   "Undefined behavior: size()-1 wraps to a huge value"
  ],
  "correctIndex": 3,
  "explanation": "s.size() is unsigned, so 0-1 wraps to SIZE_MAX and the loop reads out of bounds via operator[], which is undefined behavior."
 },
 {
  "id": 196,
  "category": "dsa-core",
  "q": "What is the output?\nint a[]={5,10,15};\nint *p=a;\ncout << *(p+2) - *p;",
  "options": [
   "5",
   "10",
   "15",
   "20"
  ],
  "correctIndex": 1,
  "explanation": "*(p+2) is 15 and *p is 5, so the result is 15-5 = 10."
 },
 {
  "id": 197,
  "category": "dsa-core",
  "q": "What is the output?\nstring s=\"abc\";\ns += 'd';\ns.insert(0, \"x\");\ncout << s;",
  "options": [
   "xabcd",
   "abcdx",
   "xabc",
   "abcd"
  ],
  "correctIndex": 0,
  "explanation": "Appending 'd' gives abcd, and inserting \"x\" at index 0 gives xabcd."
 },
 {
  "id": 198,
  "category": "dsa-core",
  "q": "What is the output?\nvector<int> v={3,1,2};\nsort(v.begin(), v.end(), greater<int>());\ncout << v[0] << v[2];",
  "options": [
   "13",
   "32",
   "31",
   "12"
  ],
  "correctIndex": 2,
  "explanation": "Descending order gives 3,2,1, so v[0]=3 and v[2]=1, which prints 31."
 },
 {
  "id": 199,
  "category": "dsa-core",
  "q": "Two-sum on an unsorted array using std::unordered_map has what average time and space complexity?",
  "options": [
   "O(n log n) time, O(1) space",
   "O(n^2) time, O(1) space",
   "O(n) time, O(log n) space",
   "O(n) time, O(n) space"
  ],
  "correctIndex": 3,
  "explanation": "One pass with average O(1) hash lookups gives O(n) time, and the map stores up to n elements."
 },
 {
  "id": 200,
  "category": "dsa-core",
  "q": "What is the output?\nstring s=\"racecar\";\nstring t(s.rbegin(), s.rend());\ncout << (s==t);",
  "options": [
   "0",
   "1",
   "racecar",
   "Compilation error"
  ],
  "correctIndex": 1,
  "explanation": "The reversed string of the palindrome \"racecar\" equals the original, so the comparison prints 1."
 },
 {
  "id": 201,
  "category": "dsa-core",
  "q": "What is the time complexity of building a string of n chars with: for(int i=0;i<n;i++) s = s + 'a'; ?",
  "options": [
   "O(n)",
   "O(n log n)",
   "O(n^2)",
   "O(1) amortized per iteration"
  ],
  "correctIndex": 2,
  "explanation": "s + 'a' creates a new string and copies the existing characters each time, so total work is O(n^2)."
 },
 {
  "id": 202,
  "category": "dsa-core",
  "q": "Which approach computes 'product of array except self' without division in O(n) time and O(1) extra space (excluding output)?",
  "options": [
   "Nested loops multiplying all other elements",
   "Prefix products in the output array, then a right-to-left running suffix product",
   "Sort the array, then multiply",
   "Use an unordered_map of products"
  ],
  "correctIndex": 1,
  "explanation": "Store left products in the output, then multiply by a running right product in a second pass."
 },
 {
  "id": 203,
  "category": "dsa-core",
  "q": "What is the output?\nvector<int> v={1,2,3,4,5};\nrotate(v.begin(), v.begin()+2, v.end());\ncout << v[0] << v[4];",
  "options": [
   "45",
   "12",
   "35",
   "32"
  ],
  "correctIndex": 3,
  "explanation": "rotate makes the array 3,4,5,1,2, so v[0]=3 and v[4]=2."
 },
 {
  "id": 204,
  "category": "dsa-core",
  "q": "Boyer-Moore majority vote is run on {2,2,1,1,1,2,2}. Which candidate does it return?",
  "options": [
   "1",
   "2",
   "The count 4",
   "No candidate"
  ],
  "correctIndex": 1,
  "explanation": "Tracing the counts gives candidate 2 at the end, and 2 appears 4 times out of 7, so it is the majority."
 },
 {
  "id": 205,
  "category": "dsa-core",
  "q": "What is the output?\nint a[3]={1,2,3};\nint *p=a+3;\ncout << p-a;",
  "options": [
   "3",
   "2",
   "Undefined behavior",
   "Compilation error"
  ],
  "correctIndex": 0,
  "explanation": "A pointer one past the end is valid, and subtracting a from it gives the element count, 3."
 },
 {
  "id": 206,
  "category": "dsa-adv",
  "q": "Which traversal of a Binary Search Tree (BST) visits the keys in ascending sorted order?",
  "options": [
   "Preorder",
   "Inorder",
   "Postorder",
   "Level order"
  ],
  "correctIndex": 1,
  "explanation": "Inorder (left, root, right) on a BST yields keys in non-decreasing order."
 },
 {
  "id": 207,
  "category": "dsa-adv",
  "q": "What is the maximum number of nodes in a binary tree of height h, if a tree with only the root has height 0?",
  "options": [
   "2^h - 1",
   "2^h",
   "2^(h+1) - 1",
   "2^(h+1)"
  ],
  "correctIndex": 2,
  "explanation": "A full tree has 1+2+4+...+2^h = 2^(h+1) - 1 nodes."
 },
 {
  "id": 208,
  "category": "dsa-adv",
  "q": "What is the time complexity of BFS on a graph with V vertices and E edges stored as an adjacency list?",
  "options": [
   "O(V*E)",
   "O(V+E)",
   "O(V^2)",
   "O(E log V)"
  ],
  "correctIndex": 1,
  "explanation": "Each vertex is enqueued once and each adjacency list is scanned once, giving O(V+E)."
 },
 {
  "id": 209,
  "category": "dsa-adv",
  "q": "Length of the Longest Increasing Subsequence of {10, 9, 2, 5, 3, 7, 101, 18}?",
  "options": [
   "3",
   "4",
   "5",
   "6"
  ],
  "correctIndex": 1,
  "explanation": "One LIS is 2,3,7,101 (or 2,5,7,18), which has length 4."
 },
 {
  "id": 210,
  "category": "dsa-adv",
  "q": "Which algorithm correctly finds single-source shortest paths when edges can have negative weights (no negative cycle)?",
  "options": [
   "Dijkstra with a min-heap",
   "Prim's algorithm",
   "Bellman-Ford",
   "Kruskal's algorithm"
  ],
  "correctIndex": 2,
  "explanation": "Bellman-Ford relaxes all edges V-1 times and handles negative weights; Dijkstra can fail."
 },
 {
  "id": 211,
  "category": "dsa-adv",
  "q": "Topological ordering of vertices exists only for which kind of graph?",
  "options": [
   "Any undirected graph",
   "Directed Acyclic Graph",
   "Any directed graph",
   "Complete graph"
  ],
  "correctIndex": 1,
  "explanation": "A topological order exists iff the directed graph has no cycles."
 },
 {
  "id": 212,
  "category": "dsa-adv",
  "q": "How many edges does a spanning tree of a connected graph with V vertices have?",
  "options": [
   "V",
   "V + 1",
   "V - 1",
   "V / 2"
  ],
  "correctIndex": 2,
  "explanation": "A spanning tree connects V vertices with no cycle, so it has exactly V-1 edges."
 },
 {
  "id": 213,
  "category": "dsa-adv",
  "q": "What is the time complexity of the standard bottom-up 0/1 knapsack DP with n items and capacity W?",
  "options": [
   "O(n + W)",
   "O(nW)",
   "O(2^n)",
   "O(n log W)"
  ],
  "correctIndex": 1,
  "explanation": "The DP table has n*W states, each computed in O(1)."
 },
 {
  "id": 214,
  "category": "dsa-adv",
  "q": "What is the length of the Longest Common Subsequence of \"ABCBDAB\" and \"BDCABA\"?",
  "options": [
   "3",
   "4",
   "5",
   "6"
  ],
  "correctIndex": 1,
  "explanation": "A classic example: LCS is length 4, for example \"BCBA\"."
 },
 {
  "id": 215,
  "category": "dsa-adv",
  "q": "Output?\nint f(int n){ return n<=1 ? 1 : f(n-1)+f(n-2); }\ncout << f(5);",
  "options": [
   "5",
   "6",
   "8",
   "13"
  ],
  "correctIndex": 2,
  "explanation": "With f(0)=f(1)=1: f(2)=2, f(3)=3, f(4)=5, f(5)=8."
 },
 {
  "id": 216,
  "category": "dsa-adv",
  "q": "Which technique detects a cycle in an undirected graph efficiently while processing edges one at a time?",
  "options": [
   "Disjoint Set Union (Union-Find)",
   "Segment tree",
   "Monotonic stack",
   "Trie"
  ],
  "correctIndex": 0,
  "explanation": "If an edge joins two vertices already in the same DSU set, it forms a cycle."
 },
 {
  "id": 217,
  "category": "dsa-adv",
  "q": "Preorder = 1 2 4 5 3 and Inorder = 4 2 5 1 3 describe a binary tree. What is its postorder?",
  "options": [
   "4 5 2 3 1",
   "4 2 5 3 1",
   "5 4 2 3 1",
   "4 5 3 2 1"
  ],
  "correctIndex": 0,
  "explanation": "Root 1; left subtree {4,2,5} has root 2 with children 4 and 5; right is 3. Postorder is 4 5 2 3 1."
 },
 {
  "id": 218,
  "category": "dsa-adv",
  "q": "What is the time complexity of Kruskal's MST algorithm using sorting and DSU?",
  "options": [
   "O(V^3)",
   "O(E log E)",
   "O(V + E)",
   "O(V^2 E)"
  ],
  "correctIndex": 1,
  "explanation": "Sorting the edges dominates at O(E log E); the DSU operations are near-constant amortized."
 },
 {
  "id": 219,
  "category": "dsa-adv",
  "q": "Coin change with coins {1,3,4} and amount 6: what is the minimum number of coins needed?",
  "options": [
   "2",
   "3",
   "4",
   "Greedy always gives 2"
  ],
  "correctIndex": 0,
  "explanation": "3+3 uses 2 coins; greedy (4+1+1) uses 3, so greedy is not optimal here."
 },
 {
  "id": 220,
  "category": "dsa-adv",
  "q": "In an AVL tree, what is the maximum allowed absolute balance factor (height difference of left and right subtrees) for any node?",
  "options": [
   "0",
   "1",
   "2",
   "log n"
  ],
  "correctIndex": 1,
  "explanation": "AVL keeps |height(left) - height(right)| <= 1 at every node, using rotations."
 },
 {
  "id": 221,
  "category": "dsa-adv",
  "q": "Recursive DFS on a skewed binary tree with n nodes uses how much auxiliary stack space?",
  "options": [
   "O(1)",
   "O(log n)",
   "O(n)",
   "O(n log n)"
  ],
  "correctIndex": 2,
  "explanation": "The recursion depth equals the tree height, which is n for a skewed tree."
 },
 {
  "id": 222,
  "category": "dsa-adv",
  "q": "Output?\npriority_queue<int> pq;\npq.push(3); pq.push(1); pq.push(4);\npq.pop();\ncout << pq.top();",
  "options": [
   "1",
   "3",
   "4",
   "Undefined behavior"
  ],
  "correctIndex": 1,
  "explanation": "std::priority_queue is a max-heap, so pop removes 4 and the new top is 3."
 },
 {
  "id": 223,
  "category": "dsa-adv",
  "q": "What is the time complexity of the Floyd-Warshall all-pairs shortest path algorithm?",
  "options": [
   "O(V^2)",
   "O(V E)",
   "O(V^3)",
   "O(E log V)"
  ],
  "correctIndex": 2,
  "explanation": "It uses three nested loops over V vertices, giving O(V^3)."
 },
 {
  "id": 224,
  "category": "dsa-adv",
  "q": "In a BST built by inserting 20, 8, 22, 4, 12, 10, 14 in order, what is the LCA of nodes 10 and 14?",
  "options": [
   "8",
   "12",
   "20",
   "10"
  ],
  "correctIndex": 1,
  "explanation": "10 is in the left subtree of 12 and 14 in the right, so their split point is 12."
 },
 {
  "id": 225,
  "category": "dsa-adv",
  "q": "How many structurally distinct BSTs can be built with 4 distinct keys?",
  "options": [
   "5",
   "10",
   "14",
   "24"
  ],
  "correctIndex": 2,
  "explanation": "This is the Catalan number C4 = 14."
 },
 {
  "id": 226,
  "category": "dsa-adv",
  "q": "Dijkstra's algorithm on a graph with V vertices and E edges (non-negative weights, adjacency list) using std::priority_queue has what time complexity?",
  "options": [
   "O(V + E)",
   "O((V + E) log V)",
   "O(V * E)",
   "O(V^3)"
  ],
  "correctIndex": 1,
  "explanation": "Each edge relaxation can push into the binary heap at O(log V) cost, giving O((V+E) log V)."
 },
 {
  "id": 227,
  "category": "dsa-adv",
  "q": "Output?\nint dp[3][3];\nfor(int i=0;i<3;i++) for(int j=0;j<3;j++)\n dp[i][j] = (i==0||j==0) ? 1 : dp[i-1][j] + dp[i][j-1];\ncout << dp[2][2];",
  "options": [
   "4",
   "5",
   "6",
   "9"
  ],
  "correctIndex": 2,
  "explanation": "This counts right/down paths in a 3x3 grid. Row 1 is 1,2,3 and row 2 is 1,3,6, so dp[2][2] = 6."
 },
 {
  "id": 228,
  "category": "dsa-adv",
  "q": "What is the minimum edit distance (insert, delete, replace, each cost 1) between \"kitten\" and \"sitting\"?",
  "options": [
   "3",
   "2",
   "4",
   "5"
  ],
  "correctIndex": 0,
  "explanation": "kitten -> sitten (replace k with s) -> sittin (replace e with i) -> sitting (insert g) takes 3 operations."
 },
 {
  "id": 229,
  "category": "dsa-adv",
  "q": "A full binary tree (every node has 0 or 2 children) has 15 nodes. How many leaf nodes does it have?",
  "options": [
   "7",
   "6",
   "9",
   "8"
  ],
  "correctIndex": 3,
  "explanation": "In a full binary tree, leaves = internal nodes + 1. With n = 15, internal = 7 and leaves = 8, which is (n+1)/2."
 },
 {
  "id": 230,
  "category": "dsa-adv",
  "q": "Which algorithm finds all strongly connected components of a directed graph in O(V + E) time using a single DFS with low-link values?",
  "options": [
   "Prim's algorithm",
   "Kruskal's algorithm",
   "Tarjan's algorithm",
   "Floyd-Warshall algorithm"
  ],
  "correctIndex": 2,
  "explanation": "Tarjan's SCC algorithm uses discovery times, low-link values and a stack in one DFS pass, running in O(V+E)."
 },
 {
  "id": 231,
  "category": "os-cn",
  "q": "Which CPU scheduling algorithm can cause starvation of long processes when short jobs keep arriving?",
  "options": [
   "Round Robin",
   "FCFS",
   "Shortest Remaining Time First (SRTF)",
   "Multilevel feedback with aging"
  ],
  "correctIndex": 2,
  "explanation": "SRTF always favors the shortest remaining job, so a long job may wait indefinitely; RR and FCFS do not starve, and aging prevents starvation."
 },
 {
  "id": 232,
  "category": "os-cn",
  "q": "On Linux, how many times is 'X' printed?\n#include <cstdio>\n#include <unistd.h>\nint main(){ fork(); fork(); printf(\"X\"); }",
  "options": [
   "1",
   "2",
   "3",
   "4"
  ],
  "correctIndex": 3,
  "explanation": "Two forks create 2^2 = 4 processes, and each prints X once when its buffer flushes at exit."
 },
 {
  "id": 233,
  "category": "os-cn",
  "q": "Which of the following is NOT one of the four Coffman conditions for deadlock?",
  "options": [
   "Mutual exclusion",
   "Hold and wait",
   "Preemption of resources",
   "Circular wait"
  ],
  "correctIndex": 2,
  "explanation": "The actual condition is 'no preemption'. Resources being preemptible would break deadlock, so preemption is not a necessary condition."
 },
 {
  "id": 234,
  "category": "os-cn",
  "q": "What is the correct order of the TCP connection establishment handshake?",
  "options": [
   "SYN, SYN-ACK, ACK",
   "SYN, ACK, SYN-ACK",
   "ACK, SYN, SYN-ACK",
   "SYN-ACK, SYN, ACK"
  ],
  "correctIndex": 0,
  "explanation": "The client sends SYN, the server replies SYN-ACK, and the client confirms with ACK."
 },
 {
  "id": 235,
  "category": "os-cn",
  "q": "Which default port does HTTPS use?",
  "options": [
   "80",
   "8080",
   "443",
   "22"
  ],
  "correctIndex": 2,
  "explanation": "HTTPS (HTTP over TLS) uses TCP port 443 by default; 80 is HTTP and 22 is SSH."
 },
 {
  "id": 236,
  "category": "os-cn",
  "q": "Belady's anomaly, where more frames can cause more page faults, can occur in which page replacement algorithm?",
  "options": [
   "Optimal",
   "LRU",
   "FIFO",
   "Both Optimal and LRU"
  ],
  "correctIndex": 2,
  "explanation": "FIFO is not a stack algorithm, so it can show Belady's anomaly. Optimal and LRU are stack algorithms and do not."
 },
 {
  "id": 237,
  "category": "os-cn",
  "q": "FIFO page replacement, 3 frames, reference string 1 2 3 4 1 2 5 1 2 3 4 5. How many page faults occur?",
  "options": [
   "8",
   "9",
   "10",
   "12"
  ],
  "correctIndex": 1,
  "explanation": "Simulating FIFO with 3 frames gives faults on 1,2,3,4,1,2,5,3,4, which is 9 (hits on the 1 and 2 after 5, and the final 5)."
 },
 {
  "id": 238,
  "category": "os-cn",
  "q": "Two threads each run 'for(int i=0;i<100000;i++) counter++;' on a shared plain int counter. After both join, the result is:",
  "options": [
   "Always 200000",
   "Always less than 200000",
   "Undefined behavior due to a data race",
   "Compile error"
  ],
  "correctIndex": 2,
  "explanation": "Unsynchronized concurrent writes to a non-atomic variable are a data race, which is undefined behavior in C++."
 },
 {
  "id": 239,
  "category": "os-cn",
  "q": "Two threads each do 'c.fetch_add(1)' 1000 times on a shared std::atomic<int> c (initially 0). After both are joined, c equals:",
  "options": [
   "Between 1000 and 2000",
   "Exactly 2000",
   "Exactly 1000",
   "Undefined"
  ],
  "correctIndex": 1,
  "explanation": "fetch_add is atomic, so no increments are lost and the final value is exactly 2000."
 },
 {
  "id": 240,
  "category": "os-cn",
  "q": "How many usable host addresses are in the subnet 192.168.1.0/26?",
  "options": [
   "64",
   "62",
   "30",
   "126"
  ],
  "correctIndex": 1,
  "explanation": "/26 leaves 6 host bits, so 2^6 = 64 addresses, minus network and broadcast = 62."
 },
 {
  "id": 241,
  "category": "os-cn",
  "q": "What is the primary purpose of the TLB (Translation Lookaside Buffer)?",
  "options": [
   "Cache recently used page table entries",
   "Cache disk blocks",
   "Store process control blocks",
   "Hold swapped-out pages"
  ],
  "correctIndex": 0,
  "explanation": "The TLB is a small hardware cache of virtual-to-physical translations that avoids a page table walk on each memory access."
 },
 {
  "id": 242,
  "category": "os-cn",
  "q": "Which resource is NOT shared between threads of the same process?",
  "options": [
   "Heap memory",
   "Global variables",
   "Open file descriptors",
   "Stack"
  ],
  "correctIndex": 3,
  "explanation": "Each thread has its own stack and registers; heap, globals and file descriptors are shared."
 },
 {
  "id": 243,
  "category": "os-cn",
  "q": "A binary semaphore is initialized to 1. Thread A calls wait() and then calls wait() again without any signal(). What happens?",
  "options": [
   "It proceeds, and the value becomes -1",
   "It blocks on the second wait()",
   "The semaphore resets to 1",
   "It throws an exception"
  ],
  "correctIndex": 1,
  "explanation": "The first wait takes the value to 0, so the second wait blocks until another thread calls signal()."
 },
 {
  "id": 244,
  "category": "os-cn",
  "q": "What happens when f(1) is called?\nstd::mutex m;\nvoid f(int n){ std::lock_guard<std::mutex> g(m); if(n>0) f(n-1); }",
  "options": [
   "Runs normally, locking twice",
   "Throws std::bad_alloc",
   "Compile error",
   "Undefined behavior, typically deadlock"
  ],
  "correctIndex": 3,
  "explanation": "std::mutex is non-recursive, so locking it again in the same thread is UB and usually deadlocks; std::recursive_mutex would be needed."
 },
 {
  "id": 245,
  "category": "os-cn",
  "q": "Round Robin, quantum 2, all arrive at t=0 in order P1(burst 5), P2(3), P3(1). What is the average waiting time?",
  "options": [
   "3.67",
   "4.00",
   "4.33",
   "5.00"
  ],
  "correctIndex": 2,
  "explanation": "Completion times are P1=9, P2=8, P3=5, so waiting times are 4, 5, 4 and the average is 13/3 ≈ 4.33."
 },
 {
  "id": 246,
  "category": "os-cn",
  "q": "Which transport protocol and port do standard DNS queries use by default?",
  "options": [
   "TCP port 25",
   "UDP port 53",
   "UDP port 67",
   "TCP port 80"
  ],
  "correctIndex": 1,
  "explanation": "Standard DNS queries use UDP port 53, falling back to TCP for large responses and zone transfers."
 },
 {
  "id": 247,
  "category": "os-cn",
  "q": "At which OSI layer does a router primarily operate when forwarding packets?",
  "options": [
   "Data link layer",
   "Transport layer",
   "Physical layer",
   "Network layer"
  ],
  "correctIndex": 3,
  "explanation": "Routers forward packets using IP addresses, which is Layer 3, the network layer."
 },
 {
  "id": 248,
  "category": "os-cn",
  "q": "In Unix, what is a zombie process?",
  "options": [
   "A process stuck in an infinite loop",
   "A terminated child whose exit status the parent has not collected",
   "A process with no parent",
   "A process swapped out to disk"
  ],
  "correctIndex": 1,
  "explanation": "A zombie has exited but still has a process table entry until the parent calls wait()."
 },
 {
  "id": 249,
  "category": "os-cn",
  "q": "What is the output?\nint x=10;\nif(fork()==0){ x+=5; printf(\"%d \",x); }\nelse { wait(NULL); printf(\"%d\",x); }",
  "options": [
   "15 15",
   "10 15",
   "15 10",
   "10 10"
  ],
  "correctIndex": 2,
  "explanation": "Parent and child have separate address spaces. The child prints 15, then the parent, after wait, prints its own x, which is still 10."
 },
 {
  "id": 250,
  "category": "os-cn",
  "q": "In C++17, what is the main advantage of std::scoped_lock(m1, m2) over locking m1 and m2 one after another?",
  "options": [
   "It makes the mutexes recursive",
   "It acquires multiple mutexes using a deadlock-avoidance algorithm",
   "It allows shared (reader) access",
   "It makes the mutexes atomic"
  ],
  "correctIndex": 1,
  "explanation": "scoped_lock locks all given mutexes as if by std::lock, avoiding deadlock from inconsistent lock ordering, and releases them via RAII."
 }
];
export const CATEGORIES = [
 {
  "id": "cpp-core",
  "label": "C++ Fundamentals",
  "count": 35
 },
 {
  "id": "oop",
  "label": "OOP & Inheritance",
  "count": 30
 },
 {
  "id": "stl",
  "label": "STL Containers & Algorithms",
  "count": 30
 },
 {
  "id": "templates",
  "label": "Templates & Generic Programming",
  "count": 20
 },
 {
  "id": "memory",
  "label": "Memory & Smart Pointers",
  "count": 20
 },
 {
  "id": "modern",
  "label": "Modern C++ (11/14/17/20)",
  "count": 20
 },
 {
  "id": "exceptions",
  "label": "Exceptions & RAII",
  "count": 10
 },
 {
  "id": "concurrency",
  "label": "Concurrency",
  "count": 10
 },
 {
  "id": "dsa-core",
  "label": "DSA - Arrays/Strings/Lists",
  "count": 30
 },
 {
  "id": "dsa-adv",
  "label": "DSA - Trees/Graphs/DP",
  "count": 25
 },
 {
  "id": "os-cn",
  "label": "OS & Networking",
  "count": 20
 }
];
